import React, { useState, useEffect, useRef } from "react";
import Layout from "../../../components/layout/layout";
import { Search, Filter, Download, Loader, NotepadText } from "lucide-react";
import { Pencil } from "lucide-react";
import { Trash } from "lucide-react";
import DistributeFunds from "../../../assets/icons/distributeFunds.svg";
import teamIconDisabled from "../../../assets/icons/teamIconDisabled.svg";
import { X } from "lucide-react";
import emtyimg from "../../../assets/image/setUpTeams.png";
import noActivityImg from "../../../assets/image/emtyimg.png";
import { Star, Camera, ChevronDown, ChevronUp } from "lucide-react";
import { setUser } from "../../../store/authSlice";
import { createNotification } from "../../../store/slices/notificationSlice";
import { Check, Plus, Building2 } from "lucide-react";
import ViewModel from "../../../common/ViewModel/ViewModel";
import teamRoleMemberimg from "../../../assets/image/teamRoleMemberimg.png";
import { ArrowLeft, Clock, MailCheck } from "lucide-react";
import { db, storage } from "../../../config/firebase";
import FilterModelTeam from "./FilterModelTeam";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getNameFromEmail, mapSingleRole } from "../../../utils/common";
import { useAppState } from "../../../hooks/useAppState";
import { useDispatch, useSelector } from "react-redux";
import {
  addFunds,
  transferFunds,
  getOrCreateWallet,
} from "../../../services/walletService";
import {
  fetchAllTeamData,
  fetchTeamActivities,
  filterMembersTeams,
  distributeFunds,
  updateMemberWalletBalance,
  updateMemberBalanceInState,
  addMemberToState, // <-- import the new action
  setEnhancedMembers,
  updateMemberAfterSave, // <-- import the new action
  setupCurrentTeamListener, // <-- import current team listener
  cleanupCurrentTeamListener, // <-- import current team cleanup
} from "../../../store/slices/teamSlice";
import csc from "countrycitystatejson";

import { useWallet } from "../../../hooks/useWallet";
import { useAppSelector } from "../../../store/hooks";
import { AppDispatch, RootState } from "../../../store";
import { getTimestamp } from "../../Admin/directory/utils";
import {
  collection,
  query,
  where,
  getDocs,
  updateDoc,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";
import { fetchUserRatingAndReviews, logActivity } from "../../../store/profileSlice";
import { getStateFullName } from "../../../common/AddressControl/stateNameMapper";
import { getCountryFullName } from "../../../common/AddressControl/countryNameMapper";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
interface FormData {
  fullName: string;
  email: string;
  role: string;
  orgName?: string;
  orgUrl?: string;
  taxId?: string;
  addressLine1?: string;
  addressLine2?: string;
  country?: string;
  state?: string;
  city?: string;
  zipCode?: string;
  teamName?: string;
  availability?: boolean;
}

interface ConsultationType {
  id: number;
  status: string;
  customerName: string;
  customerInitials: string;
  expertName: string;
  expertInitials: string;
  role: string;
  startTime: string;
  duration: string;
  rating: number;
  amount: string;
  review?: string;
}
const TeamsCustomer = () => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    members,
    filteredMembers,
filteredMembersLoading,
    status,
    currentTeam,
    teamActivities,
    activitiesLoading,
    activitiesError,
  } = useSelector((state: any) => state.team);
  const orgData = useAppSelector(
    (state: RootState) => state.organization.currentOrganization
  );
  // Add selectors for user ratings
  const userRatings = useSelector(
    (state: RootState) => state.profile.userRatings
  );
  const ratingsLoading = useSelector(
    (state: RootState) => state.profile.ratingsLoading
  );
  console.log(filteredMembersLoading,"filteredMembersLoading")
  console.log(filteredMembers, "filteredMembers");
  const { wallet } = useWallet();
  // Local state
  const { user } = useAppState();

  // Use Redux loading state instead of local state
  const loading = status === 'loading' || status === 'idle';
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState("Directory");
  const [addMember, setAddMember] = useState(false);
  const [inviteSuccess, setInviteSuccess] = useState(false); // Add state for invitation success
  const [inviteFormData, setInviteFormData] = useState({ email: "", role: "" }); // Add state for invite form
  const [isInviteFormValid, setIsInviteFormValid] = useState(false); // Add state to track form validity
  const [formErrors, setFormErrors] = useState({
    email: "",
    role: "",
    general: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [activitySearchTerm, setActivitySearchTerm] = useState("");
  // const [totalDistributed] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [activityCurrentPage, setActivityCurrentPage] = useState(1);
  const [isInviting, setIsInviting] = useState(false); // Add state to track invitation process
  const itemsPerPage = 10;
  const [profileViewModel, setProfileViewModel] = useState(false);
  const [EditeModel, setEditModel] = useState(false);
  const [distributeFundModel, setDistributeFundModel] = useState(false);
  const [setupTeamModel, setSetUpTeamModel] = useState(false);
  const [setupTeamLoading, setSetupTeamLoading] = useState(false);
  const [viewModelOpen, setViewModelOpen] = useState(false);
  const [filterViewModel, setFilterViewModel] = useState(false);
  const [activityIssueRefundModel, setActivityIssueRefundModel] =
    useState(false);
  const [sections, setSections] = useState({
    status: true,
    role: true,
    wallet: true,
    amount: true,
    rating: true,
  });
  const [customWallet, setCustomWallet] = useState(false);
  const [customAmount, setCustomAmount] = useState(false);
  const [filterCriteria, setFilterCriteria] = useState({
    status: "",
    role: "",
    walletRange: [] as string[],
    amountRange: [] as string[],
    customWalletMin: "",
    customWalletMax: "",
    customAmountMin: "",
    customAmountMax: "",
    rating: "",
  });
  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
    role: "",
    avatar: "",
    status: "",
    rating: "0.0",
    reviewCount: "0",
    lastActive: "",
    totalSessions: "0",
    walletBalance: "0",
    totalAmount: "0",
    profileData: null as any,
    userData: null as any,
  });
  console.log(profileData, "profileData from teamCustomer");
  const [formData, setFormData] = useState<FormData>({
    fullName: "",
    email: "",
    role: "",
    orgName: "",
    orgUrl: "",
    taxId: "",
    addressLine1: "",
    addressLine2: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    teamName: "",
    availability: false,
  });
  const [selectedMembers, setSelectedMembers] = useState<string[]>([]);
  const [selectedMemberForEdit, setSelectedMemberForEdit] = useState<any>(null);
  console.log(selectedMemberForEdit, "selectedMemberForEdit")
  console.log(selectedMembers, "selectedMembers ");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  // refs to detect outside clicks for dropdowns
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const dropdownMembersRef = useRef<HTMLDivElement | null>(null);

  // Close dropdown on outside click or Escape key
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isDropdownOpen) return;
      const target = event.target as Node;

      const clickedInsideInvite = dropdownRef.current?.contains(target);
      const clickedInsideMembers = dropdownMembersRef.current?.contains(target);

      if (!clickedInsideInvite && !clickedInsideMembers) {
        setIsDropdownOpen(false);
      }
    };

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isDropdownOpen]);
  const [selectedActivity, setSelectedActivity] =
    useState<ConsultationType | null>(null);
  console.log(selectedActivity, "selectedActivity ");
  const [showDistributeForm, setShowDistributeForm] = useState(false);
  const [amount, setAmount] = useState(wallet?.balance || 0);
  const [distributeAmount, setDistributeAmount] = useState("");
  const [distributionMethod, setDistributionMethod] = useState("split");

  const [inputAmount, setInputAmount] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [addedAmount, setAddedAmount] = useState(0);
  const [countdown, setCountdown] = useState(3);

  const [distributing, setDistributing] = useState(false);
  const [isProcessingBalance, setIsProcessingBalance] = useState(false);
  const [selectedConsultationForRefund, setSelectedConsultationForRefund] =
    useState<ConsultationType | null>(null);
  const [billedAmount, setBilledAmount] = useState(0);
  const [refundAmount, setRefundAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const [showBalanceAdditionForm, setShowBalanceAdditionForm] = useState(false);
  const [showDistributionSuccess, setShowDistributionSuccess] = useState(false);
  const [distributedAmount, setDistributedAmount] = useState(0);
  const [requestAmount, setRequestAmount] = useState(""); // Add this line to track request amount
  const [isProcessing, setIsProcessing] = useState(false); // Add state for processing status
  const [organizationData, setOrganizationData] = useState(null); // Add state for organization data
  const [loadingOrgData, setLoadingOrgData] = useState(false); // Add loading state for org data
  const [teamSetupComplete, setTeamSetupComplete] = useState(false); // Add state for team setup completion
  // Fetch organization data when setup team modal opens
  console.log(user, "user teamCustomer");

  // Add state variables to track viewed and edited member IDs
  const [viewedMemberId, setViewedMemberId] = useState<string | null>(null);
  const [editedMemberId, setEditedMemberId] = useState<string | null>(null);

  const [viewedActivityId, setViewedActivityId] = useState<string | null>(null);
  // Add state for country and state management
  const [countries, setCountries] = useState<any[]>([]);
  const [states, setStates] = useState<any[]>([]);

  console.log(editedMemberId, "editedMemberId");
  const [uploadingImage, setUploadingImage] = useState(false);
  const shouldHighlightRow = (member: any) => {
    const memberId = member.id || member.uid;
    return memberId === viewedMemberId || memberId === editedMemberId;
  };
  // Fetch org names when selectedActivity changes
  const [expertOrgName, setExpertOrgName] = useState<string>("");
  const [expertTeamName, setExpertTeamName] = useState<string>("");
  const [customerOrgName, setCustomerOrgName] = useState<string>("");
  const [customerTeamName, setCustomerTeamName] = useState<string>("");
  const [showRequestConfirm, setShowRequestConfirm] = useState(false);
  const [pendingRequestAmount, setPendingRequestAmount] = useState<string>("");
  const [showAddConfirm, setShowAddConfirm] = useState(false);
  const [pendingAddAmount, setPendingAddAmount] = useState<string>("");
  const [showAddLimitPopup, setShowAddLimitPopup] = useState(false);
  useEffect(() => {
    const fetchOrgNames = async () => {
      setExpertOrgName("");
      setCustomerOrgName("");
      setExpertTeamName("");
      setCustomerTeamName("");
      if (selectedActivity) {
        // Fetch expert org
        const expertOrgId = selectedActivity?.expertOrganizationId;
        if (expertOrgId) {
          try {
            const orgRef = doc(db, "organizations", expertOrgId);
            const orgSnap = await getDoc(orgRef);
            if (orgSnap.exists()) {
              setExpertOrgName(orgSnap.data().name || "");
              setExpertTeamName(orgSnap.data().teamName || "");
            }
          } catch (e) {
            setExpertOrgName("");
          }
        }
        // Fetch customer org
        const customerOrgId = selectedActivity?.customerOrganizationId;
        if (customerOrgId) {
          try {
            const orgRef = doc(db, "organizations", customerOrgId);
            const orgSnap = await getDoc(orgRef);
            if (orgSnap.exists()) {
              setCustomerOrgName(orgSnap.data().name || "");
              setCustomerTeamName(orgSnap.data().teamName || "");
            }
          } catch (e) {
            setCustomerOrgName("");
          }
        }
      }
    };
    fetchOrgNames();
  }, [selectedActivity]);

  const getInitialsImage = (name: string) => {
    if (!name) return null;
    const initials = name
      .split(" ")
      .filter((part) => part.length > 0)
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
    return (
      <div className="w-[80px] h-[80px] rounded-[16px] object-cover overflow-hidden bg-[#F15D18] flex items-center justify-center">
        <span className="text-white font-bold text-xl nunito-bold">
          {initials}
        </span>
      </div>
    );
  };
  // Function to check if activity row should be highlighted
  const shouldHighlightActivityRow = (activity: any) => {
    const activityId = activity.id || activity.activityId;
    return activityId === viewedActivityId;
  };

  // Function to check if any filters are currently active
  const hasActiveFilters = () => {
    return (
      filterCriteria.status !== "" ||
      filterCriteria.role !== "" ||
      filterCriteria.walletRange.length > 0 ||
      filterCriteria.amountRange.length > 0 ||
      filterCriteria.customWalletMin !== "" ||
      filterCriteria.customWalletMax !== "" ||
      filterCriteria.customAmountMin !== "" ||
      filterCriteria.customAmountMax !== ""
    );
  };

  // Utility function to ensure wallet exists for any user
  const ensureWalletExists = async (userId: string, userRole?: string) => {
    try {
      const role = userRole || "customer_team_member";
      const walletRole = mapSingleRole(role);

      console.log(
        `Ensuring wallet exists for user ${userId} with role ${walletRole}`
      );

      const result = await getOrCreateWallet(walletRole, userId);
      console.log(`Wallet creation result for ${userId}:`, result);

      return result;
    } catch (error: any) {
      console.error(`Failed to ensure wallet for user ${userId}:`, error);
      return { success: false, error: error.message || "Unknown error" };
    }
  };

  const handleAccountStatusToggle = async (
    id: string,
    currentDisabled: boolean
  ) => {
    if (!id) return;
    setStatusLoading(true);
    try {
      const newDisabled = !currentDisabled;

      // Call Firebase function to disable/enable user account
      await updateUserAccountStatus(id, newDisabled);

      // Update selectedMemberForEdit if it's the same user being updated
      if (
        selectedMemberForEdit &&
        (selectedMemberForEdit.id === id || selectedMemberForEdit.uid === id)
      ) {
        setSelectedMemberForEdit({
          ...selectedMemberForEdit,
          userData: {
            ...selectedMemberForEdit.userData,
            disabled: newDisabled,
          },
          status: newDisabled ? "deactivated" : "active",
        });
      }

      // Update profileData if it exists
      setProfileData((prev) => ({
        ...prev,
        userData: {
          ...prev.userData,
          disabled: newDisabled,
        },
        status: newDisabled ? "deactivated" : "active",
      }));

      // Update Redux store members immediately
      const updatedMembers = members.map((member: any) =>
        member.id === id || member.uid === id
          ? {
            ...member,
            userData: {
              ...member.userData,
              disabled: newDisabled,
            },
            status: newDisabled ? "deactivated" : "active",
          }
          : member
      );

      // Dispatch updated members to Redux store
      dispatch(setEnhancedMembers(updatedMembers));

      // Update filtered members to reflect changes immediately
      dispatch(
        filterMembersTeams({
          searchTerm,
          userRole: user?.teamRole,
          userId: user?.teamId,
        })
      );
    } catch (error) {
      console.error("Failed to update account status", error);
    } finally {
      setStatusLoading(false);
    }
  };

  // Update user account status using disableUser or enableUser Firebase Function
  const updateUserAccountStatus = async (uid: string, disabled: boolean) => {
    try {
      const endpoint = disabled
        ? `https://us-central1-supporty-staging.cloudfunctions.net/disableUser/${uid}`
        : `https://us-central1-supporty-staging.cloudfunctions.net/enableUser/${uid}`;
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error("Failed to update user status");
      }

      // Store the account status in the user collection
      const userDocRef = doc(db, `users/${uid}`);
      await updateDoc(userDocRef, {
        disabled: disabled,
        updatedAt: new Date().toISOString(),
        updatedBy: user?.email || "admin",
      });

      return await response.json();
    } catch (error) {
      console.error("Error updating user account status:", error);
      throw error;
    }
  };

  const [statusLoading, setStatusLoading] = useState(false);

  // Data is already being fetched in App.tsx in background
  // Only fetch organization data and ensure wallet exists
  useEffect(() => {
    const fetchOrgData = async () => {
      if (!user?.orgId || !user?.uid) {
        setError("No organization ID or user ID found.");
        return;
      }

      setLoadingOrgData(true);
      setError(null);

      try {
        // Ensure current user's wallet exists first
        const userWalletRole = mapSingleRole(user?.teamRole);
        const walletResult = await getOrCreateWallet(userWalletRole, user?.uid);
        if (walletResult.success) {
          console.log("Current user wallet ensured:", user?.uid, walletResult);
        } else {
          console.warn("Failed to create user wallet:", walletResult.error);
        }

        // Fetch organization details and populate form data
        if (user?.orgId) {
          const orgRef = doc(db, "organizations", user.orgId);
          const orgSnapshot = await getDoc(orgRef);

          if (orgSnapshot.exists()) {
            const orgData = orgSnapshot.data();
            setOrganizationData(orgData as any);
            setFormData((prevData) => ({
              ...prevData,
              orgName: orgData.name || "",
              orgUrl: orgData.url || "",
              teamName: orgData.teamName || "",
              taxId: orgData.taxId || "",
              addressLine1: orgData.billingAddress?.address_1 || "",
              addressLine2: orgData.billingAddress?.address_2 || "",
              country: orgData.billingAddress?.country || "",
              state: orgData.billingAddress?.state || "",
              city: orgData.billingAddress?.city || "",
              zipCode: orgData.billingAddress?.postcode || "",
            }));
          }
        }
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError("Failed to load organization data. Please try again.");
      } finally {
        setLoadingOrgData(false);
      }
    };

    if (user?.orgId && user?.uid) {
      fetchOrgData();
    }
  }, [user?.orgId, user?.uid, user?.teamRole, setupTeamModel]);

  // Load countries on component mount
  useEffect(() => {
    try {
      const countryList = csc.getCountries();
      console.log("Country data structure:", countryList);
      // Ensure countryList is an array and has the expected structure
      if (Array.isArray(countryList)) {
        setCountries(countryList);
      } else {
        console.warn("Countries data is not in expected format:", countryList);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error loading countries:", error);
      setCountries([]);
    }
  }, []);

  // Handle state loading when formData.country changes
  useEffect(() => {
    if (formData.country) {
      try {
        const selectedCountry = csc.getCountryByShort(formData.country);
        const statesData = selectedCountry?.states || {};

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          statesList = Object.keys(statesData);
        } else {
          console.warn(
            "States data is neither array nor object for country:",
            formData.country,
            statesData
          );
          statesList = [];
        }

        setStates(statesList);
        console.log(
          "States loaded for country",
          formData.country,
          ":",
          statesList.length,
          "states"
        );
      } catch (error) {
        console.error(
          "Error loading states for country:",
          formData.country,
          error
        );
        setStates([]);
      }
    } else {
      setStates([]);
    }
  }, [formData.country]);
  // Update filtered members when search term changes
  useEffect(() => {
    if (members?.length > 0 && user) {
      dispatch(
        filterMembersTeams({
          searchTerm,
          userRole: user?.teamRole,
          userId: user?.teamId,
        })
      );
    }
  }, [dispatch, members, user, searchTerm]); // Fetch team activities when tab is Activity and team data is loaded
 
  useEffect(() => {
    if (
      activeTab === "Activity" &&
      user?.uid &&
      user?.orgId &&
      (user?.uiRole || user?.teamRole) &&
      currentTeam &&
      status === "succeeded"
    ) {
      console.log("Fetching team activities with params:", {
        userRole:  user?.teamRole,
        orgId: user?.orgId,
        userId: user?.uid,
        currentTeam: currentTeam,
      });

      dispatch(
        fetchTeamActivities({
          userRole:  user?.teamRole,
          orgId: user?.orgId,
          userId: user?.teamId,
          currentTeam: currentTeam,
        })
      );
    }
  }, [dispatch, activeTab, user, currentTeam, status]);


  const handleAddBalance = async (amount: string) => {
    if (!user?.uid || !amount || isNaN(Number(amount)) || Number(amount) <= 0) {
      return;
    }
    // If amount > 5000, show limit popup
    if (Number(amount) > 5000) {
      setPendingAddAmount(amount);
      setShowAddLimitPopup(true);
      return;
    }
    // If amount > 999, show confirmation popup first
    if (Number(amount) > 999 && !showAddConfirm) {
      setPendingAddAmount(amount);
      setShowAddConfirm(true);
      return;
    }

    try {
      setIsProcessingBalance(true);
      const numAmount = Number(amount);

      // Call the Firebase function to process the top-up
      try {
        const response = await fetch(
          `https://us-central1-supporty-staging.cloudfunctions.net/addTopup`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              userId: orgData?.wpCustomerId,
              amount: numAmount,
              currency: "USD",
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        console.log("Parsed response data:", responseData);

        // Create notification for funds added
        if (user?.uid) {
          dispatch(
            createNotification({
              userId: user?.uid,
              userEmail: user?.email || "Unknown",
              message: `Amount $${numAmount.toFixed(
                2
              )} was added to your wallet`,
              trigger: "funds_added",
              triggeredBy: user?.uid || "unknown",
              meta: {
                amount: numAmount,
                walletId: wallet?.id || user?.uid,
                addedAt: new Date().toISOString(),
                addedBy: user?.uid,
                adderName: user?.name || "User",
                previousBalance: wallet?.balance || 0,
                newBalance: (wallet?.balance || 0) + numAmount,
                paymentId: responseData.data?.paymentId,
                orderId: responseData.data?.orderId,
              },
            })
          );
        }

        if (responseData && responseData.success) {
          // Update local wallet service to reflect the changes
          await addFunds(
            wallet?.id || user?.uid,
            numAmount,
            user?.uid,
            "Wallet top-up via Stripe"
          );
          // Update local state
          setAmount((wallet?.balance || 0) + numAmount);
          setAddedAmount(numAmount);
          setInputAmount("");
          setShowSuccess(true);

          // Update user in global state
          dispatch(
            setUser({
              ...user,
              amount: (wallet?.balance || 0) + numAmount,
            })
          );
        } else {
          throw new Error(responseData?.message || "Failed to process payment");
        }
      } catch (error) {
        console.error("Error calling addTopup function:", error);
        throw error;
      }
    } catch (error: any) {
      console.error("Error adding balance:", error);
      alert(`Failed to add balance: ${error.message || "Unknown error"}`);
    } finally {
      setIsProcessingBalance(false);
    }
  };

  const handleCloseBalanceForm = () => {
    console.log("Closing balance form");
    setShowBalanceAdditionForm(false);
    setShowSuccess(false);
    setInputAmount("");
    setRequestAmount("");
  };

  const handleShowBalanceAdditionForm = () => {
    console.log(
      "handleShowBalanceAdditionForm called, current state:",
      showBalanceAdditionForm
    );
    setShowBalanceAdditionForm((prevState) => {
      console.log("Toggling from", prevState, "to", !prevState);
      return !prevState;
    });
  };

  const onClose = () => {
    setProfileViewModel(false);
    setViewedMemberId(null); // Reset viewed member ID
  };

  const handleView = (member: any) => {
    setViewedMemberId(member.id || member.uid); // Set viewed member ID
    setProfileData({
      status:
        member.userData?.disabled === true
          ? "deactivated"
          : member.userData?.disabled === false
            ? "active"
            : member.status,
      name: member.name,
      email: member.email,
      role: member.profileData?.teamRole,
      avatar: member.avatar || "",
      rating: "0.0",
      reviewCount: "0",
      lastActive: member.lastActivitycustomer,
      profileData: member.profileData,
      userData: member.userData, // Include userData for status checking
      totalSessions: member.sessions,
      walletBalance: member.wallet.replace("$", ""),
      totalAmount: member.totalSpent.replace("$", ""),
    });
    setProfileViewModel(true);
    setSelectedMemberForEdit(member);
    setSelectedActivity(member);
    // Fetch ratings for customer
    if (member.id || member.uid) {
      dispatch(
        fetchUserRatingAndReviews({
          userId: member.id || member.uid,
          role: "Customer",
        })
      );
    }
  };

  // 1. Define the function somewhere in your component file or a utils file
  function formatRole(role: any) {
    switch (role) {
      case "customer_owner":
        return "Team Owner";
      case "customer_team_lead":
        return "Team Lead";
      case "customer_team_member":
        return "Team Member";
      default:
        return "Customer";
    }
  }
  const getStatusColor = (status: any) => {
    switch (status) {
      case "active":
        return "bg-[#2E9D2A] border-[15px] border-green-50";
      case "deactivated":
        return "bg-[#D5332A] border-[15px] border-red-50";
      case "invited":
        return "bg-[#FFE500] border-[15px] border-yellow-50";
      default:
        return;
    }
  };

  const renderStatusLabel = (status: any) => {
    if (status === "invited") return "Invite sent";
    if (status === "deactivated") return "Deactivated";
    if (status === "active") return "Active";
    return "";
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleActivityPageChange = (pageNumber) => {
    setActivityCurrentPage(pageNumber);
  };

  const StatusIndicator = ({ status }) => (
    <div className="relative group">
      <div className={`${getStatusColor(status)} h-10 w-10 rounded-full`}></div>
      <div className="absolute left-4 -top-4 hidden group-hover:block bg-[#FAFAFA] text-[#696969]  shadow-lg text-xs py-1 px-2 rounded-lg whitespace-nowrap">
        {renderStatusLabel(status)}
      </div>
    </div>
  );

  const handleClose = () => {
    setEditModel(false);
    setFormData({ fullName: "", email: "", role: "" });
    setProfileViewModel(false);
    // Don't reset showBalanceAdditionForm here - let it be controlled independently
    // setShowBalanceAdditionForm(false);
    setSetUpTeamModel(false);
    setViewedMemberId(null); // Reset viewed member ID
    setEditedMemberId(null); // Reset edited member ID
    setViewedActivityId(null); // Reset viewed activity ID
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Handle state loading when country changes
    if (name === "country" && value) {
      try {
        const selectedCountry = csc.getCountryByShort(value);
        const statesData = selectedCountry?.states || {};

        let statesList: string[] = [];

        // Handle different data formats from the library
        if (Array.isArray(statesData)) {
          statesList = statesData;
        } else if (typeof statesData === "object" && statesData !== null) {
          statesList = Object.keys(statesData);
        } else {
          console.warn(
            "States data is neither array nor object for country:",
            value,
            statesData
          );
          statesList = [];
        }

        setStates(statesList);

        // Reset the state field when country changes
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          state: "",
        }));
      } catch (error) {
        console.error("Error loading states for country:", value, error);
        setStates([]);
      }
    } else if (name === "country" && !value) {
      // Clear states when no country is selected
      setStates([]);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        state: "",
      }));
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setSetupTeamLoading(true);

      // Create team document in Firestore
      if (user?.uid && user?.orgId && formData.teamName) {
        const teamRef = doc(db, "organizations", user?.orgId, "teams", user?.uid);

        const teamData = {
          teamName: formData.teamName,
          default: true,
          users: [],
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };

        await setDoc(teamRef, teamData);

        // Update organization document with team details
        const orgRef = doc(db, "organizations", user?.orgId);
        const orgSnapshot = await getDoc(orgRef);

        if (orgSnapshot.exists()) {
          const currentOrgData = orgSnapshot.data();

          // Prepare update data with proper null checks
          const updateData: any = {
            ...currentOrgData,
            updatedAt: new Date().toISOString(),
          };

          // Only update fields if they have valid values
          if (formData.orgName || currentOrgData.name) {
            updateData.name = formData.orgName || currentOrgData.name;
          }

          if (formData.orgUrl || currentOrgData.url) {
            updateData.url = formData.orgUrl || currentOrgData.url;
          }
          if (formData.teamName || currentOrgData.teamName) {
            updateData.teamName = formData.teamName || currentOrgData.teamName;
          }

          // Allow Tax ID to be empty - always update it with the form value
          updateData.taxId = formData.taxId || "";

          // Handle billing address with proper null checks
          const currentBillingAddress = currentOrgData.billingAddress || {};
          updateData.billingAddress = {
            address_1:
              formData.addressLine1 || currentBillingAddress.address_1 || "",
            address_2:
              formData.addressLine2 || currentBillingAddress.address_2 || "",
            country: formData.country || currentBillingAddress.country || "",
            state: formData.state || currentBillingAddress.state || "",
            city: formData.city || currentBillingAddress.city || "",
            postcode: formData.zipCode || currentBillingAddress.postcode || "",
          };

          await setDoc(orgRef, updateData, { merge: true });
        }

        // Show success notification
        dispatch(
          createNotification({
            userId: user?.uid,
            userEmail: user?.email || "",
            message: `Team "${formData.teamName}" has been successfully created`,
            trigger: "team_created",
            triggeredBy: user?.uid,
          })
        );

        // Refresh team data
        dispatch(
          fetchAllTeamData({
            orgId: user?.orgId,
            userId: user?.teamId,
            currentId: user?.uid,
            userRole: user?.uiRole || user?.teamRole,
          })
        );

        // Set team setup complete state
        setTeamSetupComplete(true);

        handleClose();
      }
    } catch (error) {
      console.error("Error creating team:", error);
      setError("Failed to create team. Please try again.");
    } finally {
      setSetupTeamLoading(false);
    }
  };

  const handleEdit = (member: any) => {
    setEditedMemberId(member.id || member.uid); // Set edited member ID
    setSelectedMemberForEdit(member);
    setFormData({
      fullName: member.name,
      email: member.email,
      role: member.profileData?.teamRole,
    });
    setProfileViewModel(false);
    setEditModel(true);
  };
  const handleInviteMember = async (e: React.FormEvent) => {
    e.preventDefault(); // Prevent form from submitting and refreshing page
    try {
      setFormErrors({ email: false, role: false, general: "" });

      // Validate inputs
      if (!inviteFormData.email.trim()) {
        setFormErrors((prev) => ({ ...prev, email: true }));
        return;
      }

      if (!inviteFormData.role) {
        setFormErrors((prev) => ({ ...prev, role: true }));
        return;
      }

      setIsInviting(true);

      // Get Firebase Functions instance
      const functions = getFunctions();

      // Get the organization ID from the user object - fix the key name to match what's stored in user object
      const orgId = user?.orgId || "defaultOrgId";

      if (!orgId) {
        throw new Error("Organization ID not found. Please contact support.");
      }

      // Create reference to your Cloud Function
      const createInvitationFunc = httpsCallable(functions, "createInvitation");

      // Prepare the data to send to the function
      const invitationData = {
        orgId: orgId,
        firstName: getNameFromEmail(inviteFormData.email), // Simple extraction of name from email
        invitedName: user?.name,
        email: inviteFormData.email,
        role: user?.role,
        teamRole:
          inviteFormData.role === "teamLead"
            ? "customer_team_lead"
            : "customer_team_member",
        teamId: orgData?.owner?.owner, // Optional, leave empty to use default team
      };

      // Call the function
      const result = await createInvitationFunc(invitationData);

      // Handle the result
      setInviteFormData({ email: "", role: "" });
      setAddMember(false);
      setInviteSuccess(true);

      // Immediately add the invited member to the state for instant UI update
      const newMember = {
        id: result.data?.invitationId || Date.now().toString(), // fallback if no id
        uid: "", // Not yet registered
        status: "invited",
        initials: getNameFromEmail(inviteFormData.email)
          .substring(0, 2)
          .toUpperCase(),
        name: getNameFromEmail(inviteFormData.email),
        role: invitationData.teamRole,
        email: inviteFormData.email,
        sessions: "0",
        lastActivity: "",
        lastActivitycustomer: "",
        lastActivityexpert: "",
        wallet: "$0.00",
        totalSpent: "$0.00",
        avatar: null,
        isOwner: false,
        invitedById: orgData?.owner?.owner,
        invitedByName: user?.name,
        invitationId: result.data?.invitationId || "",
      };
      dispatch(addMemberToState(newMember));

      // --- Add notification for Team Member or Team Lead added ---
      dispatch(
        createNotification({
          userId: user?.uid,
          userEmail: user?.email || "",
          message:
            invitationData.teamRole === "customer_team_lead"
              ? `Team Lead "${newMember.email}" has been invited`
              : `Team Member "${newMember.email}" has been invited`,
          trigger:
            invitationData.teamRole === "customer_team_lead"
              ? "team_lead_added"
              : "team_member_added",
          triggeredBy: user?.uid,
          meta: {
            invitedEmail: newMember.email,
            invitedRole: invitationData.teamRole,
            invitationId: newMember.invitationId,
          },
        })
      );
      // ----------------------------------------------------------

      // Optionally re-run filter if search/filter is active
      if (hasActiveFilters()) {
        dispatch(
          filterMembersTeams({
            searchTerm,
            userRole: user?.teamRole,
            userId: user?.teamId,
          })
        );
      }
    } catch (error) {
      console.error("Error creating invitation:", error);
      setFormErrors((prev) => ({
        ...prev,
        general: error.message || "Failed to send invitation",
      }));
    } finally {
      setIsInviting(false);
    }
  };

  // Add a handler for form input changes
  const handleInviteFormChange = (e) => {
    const { id, value } = e.target;
    setInviteFormData((prev) => ({ ...prev, [id]: value }));

    // Update form errors state
    setFormErrors((prev) => ({
      ...prev,
      [id]: value.trim() === "",
    }));

    // Check if both fields are filled to enable the button
    const updatedData = { ...inviteFormData, [id]: value };
    setIsInviteFormValid(!!updatedData.email && !!updatedData.role);
  };

  const handleAddMemberClose = () => {
    setAddMember(false);
    setInviteSuccess(false);
  };

  const handleDistributeFundsClose = () => {
    // Close the main modal
    setDistributeFundModel(false);

    // Reset form steps
    setShowDistributeForm(false);

    // Reset member selection
    setSelectedMembers([]);

    // Reset dropdown state
    setIsDropdownOpen(false);

    // Reset distribution amount
    setDistributeAmount("");

    // Reset distribution method (if you have a default)
    setDistributionMethod("split"); // or 'distribute' based on your default

    // Reset balance addition form states
    setShowBalanceAdditionForm(false);
    setInputAmount("");
    setRequestAmount("");
    setAddedAmount("");
    setShowSuccess(false);

    // Reset processing states
    setDistributing(false);
    setIsProcessingBalance(false);
    setIsProcessing(false);

    // Reset countdown if it exists
    if (typeof setCountdown === "function") {
      setCountdown(0);
    }
  };

  const handleMemberSelect = (memberId: string) => {
    setSelectedMembers((prev) =>
      prev.includes(memberId)
        ? prev.filter((id) => id !== memberId)
        : [...prev, memberId]
    );
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleActivityView = (consultation: ConsultationType) => {
    // Set the viewed activity ID for highlighting
    setViewedActivityId(consultation.id || consultation.activityId);

    // Fetch ratings for both expert and customer
    if (consultation.expertId || consultation.expertData?.id) {
      dispatch(
        fetchUserRatingAndReviews({
          userId: consultation.expertId || consultation.expertData.id,
          role: "Expert",
        })
      );
    }

    if (consultation.customerId || consultation.customerData?.id) {
      dispatch(
        fetchUserRatingAndReviews({
          userId: consultation.customerId || consultation.customerData.id,
          role: "Customer",
        })
      );
    }

    // Convert team activity to format expected by ViewModel
    const formattedActivity = {
      ...consultation,
      id: consultation.id,
      expertName:
        consultation.expertData?.name ||
        consultation.expertName ||
        "Unknown Expert",
      expertEmail:
        consultation.expertData?.email ||
        `${consultation.expertName
          ?.toLowerCase()
          .replace(/\s+/g, "")}@gmail.com`,
      expertRating: consultation.expertRating || consultation.rating,
      customerName:
        consultation.customerData?.name ||
        consultation.customerName ||
        "Unknown Customer",
      customerEmail:
        consultation.customerData?.email ||
        `${consultation.customerName
          ?.toLowerCase()
          .replace(/\s+/g, "")}@gmail.com`,
      customerRating: consultation.customerRating,
      customerReview: consultation.customerReview || "",
      activityType: consultation.type || "Video Call",
      startTime: (() => {
        if (consultation.startTime?.seconds) {
          return new Date(
            consultation.startTime.seconds * 1000
          ).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          });
        } else if (consultation.startTime) {
          return consultation.startTime;
        } else if (consultation.createdAt?.seconds) {
          return new Date(
            consultation.createdAt.seconds * 1000
          ).toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          });
        }
        return "N/A";
      })(),
      duration: (() => {
        const duration = consultation.duration;
        if (!duration) return "- mins";

        if (typeof duration === "object" && duration.hours !== undefined) {
          const { hours = 0, minutes = 0, seconds = 0 } = duration;
          if (hours > 0) {
            return `${hours}h ${minutes}m`;
          } else if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
          } else {
            return `${seconds}s`;
          }
        }

        if (typeof duration === "number") {
          return `${duration} mins`;
        }

        if (typeof duration === "string") {
          return duration.includes("min") ? duration : `${duration} mins`;
        }

        return "- mins";
      })(),
      amount:
        consultation.totalAmount?.toFixed(2) ||
        consultation.amount?.replace("$", "") ||
        "0.00",
      refundAmount:
        consultation.refundAmount?.toFixed(2) ||
        consultation.refund?.toFixed(2) ||
        consultation.savings?.toFixed(2) ||
        "0.00",
    };

    setSelectedActivity(formattedActivity);
    setViewModelOpen(true);
  };

  // Add handler for editing activity from the ViewModel component
  const handleActivityEditFromViewModel = (data: any) => {
    // Update the selected activity with the new data from ViewModel
    setSelectedActivity(data);

    // Re-fetch activities to ensure data consistency
    if (
      user?.uid &&
      user?.orgId &&
      (user?.uiRole || user?.teamRole) &&
      currentTeam
    ) {
      dispatch(
        fetchTeamActivities({
          userRole:  user?.teamRole,
          orgId: user?.orgId,
          userId: user?.teamId,
          currentTeam: currentTeam,
        })
      );
    }

    // Keep ViewModel open to show updated data
    setViewModelOpen(true);
  };
  const ActivityTable = () => {
    // Get filtered activities first
    const filteredActivities = getFilteredActivities();

    // Pagination calculations for activities
    const startIndex = (activityCurrentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedActivities =
      filteredActivities?.slice(startIndex, endIndex) || [];
    const totalActivityPages = Math.ceil(
      (filteredActivities?.length || 0) / itemsPerPage
    );

    return (
      <>
      <div className="bg-white rounded-[12px] border-[1px] border-[#EBEBEB] overflow-hidden" style={{
          height: "calc(80vh - 135px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}>
        
        <table className="min-w-full divide-y max-h-[751px] divide-gray-200 ">
          <thead className="bg-[#FEF0EA]">
            <tr>
              <th className="px-3 py-3 text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Status
              </th>
              <th className="px-3 py-3 text-left   tracking-wider">
                <div className="flex items-center  text-[14px] nunito-semibold text-[#404040] justify-between">
                  Customer Name
                </div>
              </th>
              <th className="px-3 py-3 text-left text-xs font-medium text-[#404040]  tracking-wider">
                <div className="flex items-center  text-[14px] nunito-semibold text-[#404040] justify-between">
                  Expert Name{" "}
                </div>
              </th>
              <th className="px-3 py-3 text-left text-[14px]  nunito-semibold text-[#404040]  tracking-wider">
                Customer Role
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Start Time
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Duration
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]   tracking-wider">
                Rating
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Amount
              </th>
              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                Action
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {activitiesLoading ? (
              <tr>
                <td colSpan={9} className="text-center py-10">
                  <div className="flex justify-center">
                    <Loading />
                  </div>
                </td>
              </tr>
            ) : activitiesError ? (
              <tr>
                <td colSpan={9} className="text-center py-10">
                  <div className="text-red-500">
                    Error loading activities: {activitiesError}
                  </div>
                </td>
              </tr>
            ) : paginatedActivities && paginatedActivities.length > 0 ? (
              paginatedActivities.map((activity) => (
                <tr
                  key={activity.id}
                  className={
                    shouldHighlightActivityRow(activity)
                      ? "bg-gray-100"
                      : "bg-white"
                  }
                >
                  <td className="px-3  py-3 flex items-center justify-center">
                    <div
                      className={`w-10 h-10 rounded-full ${activity.status === "completed"
                          ? "bg-[#2E9D2A14]"
                          : activity.status === "active"
                            ? "bg-[#0000FF14]"
                            : activity.hasIssue
                              ? "bg-[#D5332A14]"
                              : "bg-[#2E9D2A14]"
                        } flex items-center justify-center relative group`}
                    >
                      <div
                        className={`w-3 h-3 rounded-full ${activity.status === "completed"
                            ? "bg-[#2E9D2A]"
                            : activity.status === "active"
                              ? "bg-[#0000FF]"
                              : activity.hasIssue
                                ? "bg-[#D5332A]"
                                : "bg-[#2E9D2A]"
                          }`}
                      ></div>
                      <div className="absolute left-4 -top-4 hidden group-hover:block bg-[#FAFAFA] text-[#696969] shadow-lg text-xs py-1 px-2 rounded-lg whitespace-nowrap">
                        {activity.status === "completed"
                          ? "Completed"
                          : activity.status === "active"
                            ? "Active"
                            : activity.hasIssue
                              ? "Issue Reported"
                              : "Completed"}
                      </div>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-[38px] h-[38px] rounded-full bg-gray-800 flex items-center justify-center text-white text-sm">
                        {activity.customerData?.profileImageUrl ? (
                          <img
                            className="h-[38px] w-[38px] rounded-full object-cover"
                            src={activity.customerData.profileImageUrl}
                            alt={activity.customerData?.name}
                          />
                        ) : (
                          <div className="h-[38px] w-[38px] rounded-full bg-gray-800 flex items-center justify-center text-white text-sm">
                            {activity.customerData?.name
                              ? activity.customerData.name
                                .split(" ")
                                .map((n: string) => n[0])
                                .join("")
                                .toUpperCase()
                              : "C"}
                          </div>
                        )}
                      </div>
                      <span className=" text-[14px] nunito-semibold truncate max-w-32 text-[#696969]">
                        {activity.customerData?.name || "Unknown Customer"}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-[38px] h-[38px] rounded-full bg-orange-500 flex items-center justify-center text-white text-sm">
                        {activity.expertData?.profileImageUrl ? (
                          <img
                            className="h-[38px] w-[38px] rounded-full object-cover"
                            src={activity.expertData.profileImageUrl}
                            alt={activity.expertData?.name}
                          />
                        ) : (
                          <div className="w-[38px] h-[38px] rounded-full bg-orange-500 flex items-center justify-center text-white text-sm">
                            {activity.expertData?.name
                              ? activity.expertData.name
                                .split(" ")
                                .map((n: string) => n[0])
                                .join("")
                                .toUpperCase()
                              : "E"}
                          </div>
                        )}
                      </div>
                      <span className="text-[14px] nunito-semibold truncate max-w-32 text-[#696969]">
                        {activity.expertData?.name || " "}
                      </span>
                    </div>
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
                    {formatRole(activity.customerData?.teamRole || "")}
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
                    {activity.startTime?.seconds
                      ? new Date(
                        activity.startTime.seconds * 1000
                      ).toLocaleDateString("en-US", {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric",
                      })
                      : activity.createdAt?.seconds
                        ? new Date(
                          activity.createdAt.seconds * 1000
                        ).toLocaleDateString("en-US", {
                          month: "2-digit",
                          day: "2-digit",
                          year: "numeric",
                        })
                        : ""}
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">
                    {(() => {
                      const duration = activity.duration;
                      if (!duration) return "- mins";

                      if (
                        typeof duration === "object" &&
                        duration.hours !== undefined
                      ) {
                        const {
                          hours = 0,
                          minutes = 0,
                          seconds = 0,
                        } = duration;
                        if (hours > 0) {
                          return `${hours}h ${minutes}m`;
                        } else if (minutes > 0) {
                          return `${minutes}m ${seconds}s`;
                        } else {
                          return `${seconds}s`;
                        }
                      }

                      if (typeof duration === "number") {
                        return `${duration} mins`;
                      }

                      if (typeof duration === "string") {
                        return duration.includes("min")
                          ? duration
                          : `${duration} mins`;
                      }

                      return "- mins";
                    })()}
                  </td>
                  <td className="px-3 py-3">
                    <div className="flex items-center  space-x-1">
                      <span className="text-[#696969] text-[14px] nunito-regular">
                        {activity.customerRating || 0}
                      </span>
                      <svg
                        className="w-[24px] h-[24px] text-[#F5A038] fill-[#F5A038]"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                      </svg>
                    </div>
                  </td>
                  <td className="px-3 py-3 text-[14px] nunito-regular text-[#696969]">

                    ${Number(activity.cost ?? 0).toFixed(2)}{" "}
                    {activity.hasRefund === true && (
                      <span className="text-[#F15D18] ">*</span>
                    )}
                  </td>
                  <td className="pl-3 py-3 ">
                    <div className="flex space-x-5">
                      <button
                        className="text-[#F15D18] hover:text-[#F15A29] underline"
                        onClick={() => handleActivityView(activity)}
                      >
                        View
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} className="text-center py-10 ">
                  {hasActiveFilters() &&
                    teamActivities &&
                    teamActivities.length > 0 ? (
                    <div className="flex flex-col items-center py-20">
                      <div className="w-24 h-24 mb-4 flex items-center justify-center">
                        <Search className="w-16 h-16 text-gray-400" />
                      </div>
                      <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                        Opps! No matching records found.
                      </h2>
                      <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                        Try changing the filters or search criteria to see more
                        results!
                      </p>
                    </div>
                  ) : (
                    <div className="flex flex-col items-center">
                      <img
                        src={noActivityImg}
                        className="w-[201px] h-[196px]"
                      />
                      <div className="text-[#696969] text-[16px] nunito-regular mt-4">
                        No activity yet. Encourage your team to start
                        interacting - all their actions will appear here for you
                        to track.
                      </div>
                    </div>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
        {/* Pagination */}
        {totalActivityPages > 1 && (
          <div className="py-3 flex items-center justify-center">
            <nav className="flex space-x-1">
              {[...Array(totalActivityPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handleActivityPageChange(index + 1)}
                  className={`px-2 py-1 text-[#696969] ${activityCurrentPage === index + 1
                      ? "bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border"
                      : ""
                    }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </button>
              ))}
            </nav>
          </div>
        )}
      </>
    );
  };

  const validateDistributeAmount = (value: string) => {
    const numValue = Number(value);
    const totalRequired =
      distributionMethod === "split"
        ? numValue
        : numValue * selectedMembers.length;
    return totalRequired <= (wallet?.balance || 0);
  };
  const handleDistribute = async () => {
    try {
      setDistributing(true);

      // Get user ID, prioritize uid over id for consistency
      const userId = user?.uid || user?.id;
      if (!userId) {
        throw new Error("User ID not found");
      }

      // Validate amount
      const amountToDistribute = parseFloat(distributeAmount);
      if (isNaN(amountToDistribute) || amountToDistribute <= 0) {
        throw new Error("Invalid amount");
      }

      // Get current balance and validate
      const currentBalance = wallet?.balance || 0;

      // Calculate total amount to distribute based on distribution method
      const totalAmount =
        distributionMethod === "split"
          ? amountToDistribute
          : amountToDistribute * selectedMembers.length;

      if (totalAmount > currentBalance) {
        throw new Error(
          `Insufficient balance. Available: $${currentBalance}, Required: $${totalAmount}`
        );
      }

      // Get organization ID for the sender wallet
      const orgId = user?.orgId;
      if (!orgId) {
        throw new Error("Organization ID not found");
      }

      // Create or ensure wallet for the sender (current user) first
      const senderWalletId = userId; // Use the current user's ID
      const senderWalletRole = mapSingleRole(user?.teamRole || user?.uiRole);

      console.log("Creating/ensuring sender wallet:", {
        senderWalletId,
        senderWalletRole,
        userId,
      });

      // Ensure sender wallet exists
      const senderWalletResult = await ensureWalletExists(
        senderWalletId,
        user?.teamRole || user?.uiRole
      );
      if (!senderWalletResult.success) {
        throw new Error(
          `Failed to create sender wallet: ${senderWalletResult.error}`
        );
      }
      console.log("Sender wallet ensured:", senderWalletResult);

      // Process each selected member
      const invalidMembers = [];
      let successCount = 0;
      const recipientEmails = [];

      // For each selected member
      for (const memberId of selectedMembers) {
        try {
          // Get member details for notification
          const memberData = filteredMembers?.find(
            (m) => m.id.toString() === memberId
          );
          const memberEmail = memberData?.email;

          if (!memberEmail) {
            invalidMembers.push(memberId);
            continue;
          }

          // Calculate amount for this recipient
          const recipientAmount =
            distributionMethod === "split"
              ? amountToDistribute / selectedMembers.length
              : amountToDistribute;

          const recipientWalletRole = mapSingleRole(
            memberData?.profileData?.teamRole || "customer_team_member"
          );

          // Create or ensure recipient wallet exists
          const recipientWalletResult = await ensureWalletExists(
            memberId,
            memberData?.profileData?.teamRole
          );
          if (!recipientWalletResult.success) {
            console.error(
              `Failed to create recipient wallet for ${memberId}:`,
              recipientWalletResult.error
            );
            invalidMembers.push(memberId);
            continue;
          }

          // Transfer funds from sender wallet to member wallet
          const transferResult = await transferFunds(
            senderWalletId,
            memberId,
            recipientAmount,
            userId
          );

          if (transferResult.success) {
            successCount++;

            // Store email for sender notification
            recipientEmails.push(memberEmail); // Update member wallet balance in Redux store immediately for UI feedback
            const currentMemberBalance = parseFloat(
              memberData?.wallet?.replace("$", "") || "0"
            );
            const newMemberBalance = currentMemberBalance + recipientAmount;

            // Use both actions to ensure immediate UI update and proper state management
            dispatch(
              updateMemberBalanceInState({
                memberId: memberId,
                newBalance: newMemberBalance,
              })
            );

            dispatch(
              updateMemberWalletBalance({
                memberId: memberId,
                newBalance: newMemberBalance,
              })
            );

            // Create notification for recipient
            dispatch(
              createNotification({
                userId: memberId,
                userEmail: memberEmail,
                message: `Amount $${recipientAmount.toFixed(
                  2
                )} was added to your wallet by ${user?.email || "Team Admin"}`,
                trigger: "funds_received",
                triggeredBy: userId,
                meta: {
                  amount: recipientAmount,
                  senderName: user?.name || "Team Admin",
                  senderEmail: user?.email || "Team Admin",
                  distributionMethod: distributionMethod,
                  timestamp: new Date().toISOString(),
                },
              })
            );
          } else {
            console.error(
              `Transfer failed for user ${memberId}: ${transferResult.error}`
            );
            invalidMembers.push(memberId);
          }
        } catch (error) {
          console.error(`Error processing member ${memberId}:`, error);
          invalidMembers.push(memberId);
        }
      }

      // Update local state for sender
      setAmount(currentBalance - totalAmount);
      dispatch(
        setUser({
          ...user,
          amount: currentBalance - totalAmount,
        })
      );

      // Create notification for the sender about distributed funds
      if (recipientEmails.length > 0 && userId) {
        const emailsList = recipientEmails.join(", ");
        dispatch(
          createNotification({
            userId: userId,
            userEmail: user?.email || "",
            message: `Amount $${totalAmount.toFixed(2)} was distributed to ${recipientEmails.length
              } team member${recipientEmails.length > 1 ? "s" : ""}`,
            trigger: "funds_distributed",
            triggeredBy: userId,
            meta: {
              totalAmount: totalAmount,
              recipientCount: recipientEmails.length,
              distributionMethod: distributionMethod,
              recipientEmails: recipientEmails,
              timestamp: new Date().toISOString(),
            },
          })
        );
      }

      // Dispatch the distributeFunds action to update the Redux store
      dispatch(
        distributeFunds({
          recipientIds: selectedMembers,
          amount: amountToDistribute,
          distributionMethod: distributionMethod,
          senderWalletId: senderWalletId,
          senderId: userId,
        })
      );

      // Show success and reset form
      setDistributeFundModel(false);
      setShowDistributeForm(false);
      setSelectedMembers([]);
      setDistributeAmount("");
      setDistributedAmount(totalAmount);
      setShowDistributionSuccess(true); // Auto-hide success message after 3 seconds
      setTimeout(() => {
        setShowDistributionSuccess(false);
      }, 3000);

      // Refresh team data to show updated balances
      if (user?.orgId && user?.teamId) {
        setTimeout(() => {
          dispatch(
            fetchAllTeamData({
              orgId: user?.orgId,
              userId: user?.teamId,
              currentId: user?.uid,
              userRole:  user?.teamRole,
            })
          );
        }, 1000);
      }

      if (invalidMembers.length > 0) {
        console.warn(
          `Failed to distribute to ${invalidMembers.length} members`
        );
      }
    } catch (error) {
      console.error("Error distributing amount:", error);
      alert(`Distribution failed: ${error.message || "Please try again"}`);
    } finally {
      setDistributing(false);
    }
  };

  const handleSetupTeamClick = () => {
    setSetUpTeamModel(true);
  };
  const handleSendRequest = async (e) => {
    if (e && e.preventDefault) {
      e.preventDefault(); // Prevent form from submitting if called from form
    }

    // Don't show success if amount is empty or not a valid number
    if (
      !requestAmount ||
      isNaN(Number(requestAmount)) ||
      Number(requestAmount) <= 0
    ) {
      setIsProcessing(false);
      return;
    }
    // If amount > 999, show confirmation popup first
    if (Number(requestAmount) > 999 && !showRequestConfirm) {
      setPendingRequestAmount(requestAmount);
      setShowRequestConfirm(true);
      setIsProcessing(false);
      return;
    }
    await processRequestFunds(requestAmount);
  };

  const processRequestFunds = async (amount: string) => {
    setIsProcessing(true);
    // Get Firebase Functions instance
    const functions = getFunctions();

    // Get the organization ID from the user object - fix the key name to match what's stored in user object
    const orgId = user?.orgId || "defaultOrgId";

    if (!orgId) {
      throw new Error("Organization ID not found. Please contact support.");
    }

    // Get the organization details to find the owner
    const orgRef = doc(db, "organizations", orgId);
    const orgSnapshot = await getDoc(orgRef);
    const orgDocData = orgSnapshot.exists() ? orgSnapshot.data() : null;

    // Define ownerUid from organization document data or fallback to orgData from state
    const ownerUid = orgDocData?.owner?.owner || orgData?.owner?.owner || orgId;

    console.log("Sending fund request with ownerUid:", ownerUid);

    const createInvitationFunc = httpsCallable(functions, "requestFund");

    // Prepare the data to send to the function with proper format
    const invitationData = {
      ownerUid: ownerUid,
      orgId: orgId,
      amount: Number(amount),
      description: "Funds requested",
    };

    try {
      // Call the function
      const result = await createInvitationFunc(invitationData);

      // Log the result to check if ownerUid is properly passed
      console.log("Fund request result:", result);

      // Create notification for the fund request
      const notificationData = {
        userId: ownerUid,
        userEmail: user?.email || "Unknown",
        message: `Fund request of $${Number(amount).toFixed(2)} raised`,
        trigger: "fund_request_receive",
        triggeredBy: user?.uid || "unknown",
        meta: {
          amount: Number(amount),
          requesterEmail: user?.email || "Unknown",
          requesterName: user?.name || profileName || "Team Member",
          requesterUid: user?.uid || "unknown",
          ownerUid: ownerUid,
          status: "pending",
          customerEmail: user?.email || "Unknown",
          requestId: result?.data?.requestId || result?.data?.data?.requestId,
          requestedAt: new Date().toISOString(),
        },
      };

      dispatch(createNotification(notificationData));

      if (user?.uid && user?.uid !== ownerUid) {
        dispatch(
          createNotification({
            ...notificationData,
            userId: user?.uid,
            message: `Your fund request of $${Number(amount).toFixed(
              2
            )} is pending approval`,
            trigger: "fund_request_send",
          })
        );
      }

      setShowSuccess(true);
    } catch (error) {
      console.error("Failed to create fund request notification:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  // Function to handle tab change and reset filters
  const handleTabChange = (tab: string) => {
    setActiveTab(tab);

    // Reset all filters when changing tabs
    setSearchTerm("");
    setActivitySearchTerm("");
    setFilterCriteria({
      status: "",
      role: "",
      walletRange: [],
      amountRange: [],
      customWalletMin: "",
      customWalletMax: "",
      customAmountMin: "",
      customAmountMax: "",
      rating: "",
    });
    setCustomWallet(false);
    setCustomAmount(false);
    setCurrentPage(1);
    setActivityCurrentPage(1);

    // Reset all highlighting when changing tabs
    setViewedMemberId(null);
    setEditedMemberId(null);
    setViewedActivityId(null);
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.files || !selectedMemberForEdit.id) return;

    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploadingImage(true);

      // Create storage reference
      const storageRef = ref(storage, `profileImages/${selectedMemberForEdit.id}`);

      // Upload the file
      await uploadBytes(storageRef, file);

      // Get the download URL
      const imageUrl = await getDownloadURL(storageRef);

      // Update Firestore with the new image URL in users collection
      await updateDoc(doc(db, `users/${selectedMemberForEdit.id}`), {
        profileImageUrl: imageUrl,
      });

      // Also update the profileImageUrl in the profiles collection (query by userId)
      const profilesRef = collection(db, "profiles");
      const profileQuery = query(profilesRef, where("userId", "==", selectedMemberForEdit.id));
      const profileSnapshot = await getDocs(profileQuery);
      if (!profileSnapshot.empty) {
        const profileDoc = profileSnapshot.docs[0];
        const profileRef = doc(db, "profiles", profileDoc.id);
        await updateDoc(profileRef, {
          profileImageUrl: imageUrl,
        });

      }






      // Log activity
      if (user) {
        dispatch(
          logActivity({
            userId: selectedMemberForEdit.id,
            type: "Profile Image Update",
            metadata: { details: "Profile image updated by Owner" },
          })
        );
      }
    } catch (error) {
      console.error("Failed to upload profile image:", error);
    } finally {
      setUploadingImage(false);
    }
  }

  const Loading = () => (
    <div className=" flex flex-col max-h-[700px] justify-center items-center">
      <Loader className="animate-spin text-[#F15D18] mb-3" size={32} />
      <p className="text-gray-500 text-lg nunito-medium">Loading Team...</p>
    </div>
  );
  // Handle filter application
  const handleApplyFilters = (filters: any) => {
    setFilterCriteria(filters);
    setFilterViewModel(false);
  };

  // Apply filters to members
  const getFilteredMembers = () => {
    if (!filteredMembers) return [];

    let filtered = [...filteredMembers];

    // Apply search filter first
    if (searchTerm && searchTerm.trim() !== "") {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (member) =>
          member.name?.toLowerCase().includes(lowerSearchTerm) ||
          member.email?.toLowerCase().includes(lowerSearchTerm) ||
          member.profileData?.teamRole?.toLowerCase().includes(lowerSearchTerm)
      );
    }

    // Apply status filter
    if (filterCriteria.status && filterCriteria.status.trim() !== "") {
      filtered = filtered.filter((member) => {
        // Use the same status logic as displayed in the table
        const actualStatus = member.userData?.disabled === true
          ? "deactivated"
          : member.userData?.disabled === false
          ? "active"
          : member.status;
        
        return actualStatus === filterCriteria.status;
      });
    }
    console.log(filterCriteria, "filterCriteria");
    // Apply role filter
    if (filterCriteria.role && filterCriteria.role.trim() !== "") {
      filtered = filtered.filter(
        (member) => member.profileData?.teamRole === filterCriteria.role
      );
    }

    // Apply wallet range filter
    if (filterCriteria.walletRange && filterCriteria.walletRange.length > 0) {
      filtered = filtered.filter((member) => {
        const walletAmount = parseFloat(member.wallet.replace("$", "")) || 0;
        return filterCriteria.walletRange.some((range) => {
          switch (range) {
            case "0-100":
              return walletAmount >= 0 && walletAmount <= 100;
            case "101-200":
              return walletAmount >= 101 && walletAmount <= 200;
            case "201-300":
              return walletAmount >= 201 && walletAmount <= 300;
            case "301-400":
              return walletAmount >= 301 && walletAmount <= 400;
            case "401-500":
              return walletAmount >= 401 && walletAmount <= 500;
            case "501+":
              return walletAmount > 500;
            default:
              return true;
          }
        });
      });
    }

    // Apply custom wallet range filter
    if (filterCriteria.customWalletMin || filterCriteria.customWalletMax) {
      filtered = filtered.filter((member) => {
        const walletAmount = parseFloat(member.wallet.replace("$", "")) || 0;
        const min = parseFloat(filterCriteria.customWalletMin) || 0;
        const max = parseFloat(filterCriteria.customWalletMax) || Infinity;
        return walletAmount >= min && walletAmount <= max;
      });
    }

    // Apply amount range filter
    if (filterCriteria.amountRange && filterCriteria.amountRange.length > 0) {
      filtered = filtered.filter((member) => {
        const totalAmount = parseFloat(member.totalSpent.replace("$", "")) || 0;
        return filterCriteria.amountRange.some((range) => {
          switch (range) {
            case "0-100":
              return totalAmount >= 0 && totalAmount <= 100;
            case "101-200":
              return totalAmount >= 101 && totalAmount <= 200;
            case "201-300":
              return totalAmount >= 201 && totalAmount <= 300;
            case "301-400":
              return totalAmount >= 301 && totalAmount <= 400;
            case "401-500":
              return totalAmount >= 401 && totalAmount <= 500;
            case "501+":
              return totalAmount > 500;
            default:
              return true;
          }
        });
      });
    }

    // Apply custom amount range filter
    if (filterCriteria.customAmountMin || filterCriteria.customAmountMax) {
      filtered = filtered.filter((member) => {
        const totalAmount = parseFloat(member.totalSpent.replace("$", "")) || 0;
        const min = parseFloat(filterCriteria.customAmountMin) || 0;
        const max = parseFloat(filterCriteria.customAmountMax) || Infinity;
        return totalAmount >= min && totalAmount <= max;
      });
    }

    // Sort by createdAt (default: descending; override with filterCriteria.sortOrder)
    filtered.sort(
      (a, b) => getTimestamp(b.createdAt) - getTimestamp(a.createdAt)
    );
    return filtered;
  }; // Filter activities based on search term
  const getFilteredActivities = () => {
    if (!teamActivities) return [];

    let filtered = [...teamActivities];

    // Apply search filter
    if (activitySearchTerm && activitySearchTerm.trim() !== "") {
      const lowerSearchTerm = activitySearchTerm.toLowerCase();
      filtered = filtered.filter(
        (activity) =>
          activity.customerData?.name
            ?.toLowerCase()
            .includes(lowerSearchTerm) ||
          activity.expertData?.name?.toLowerCase().includes(lowerSearchTerm) ||
          activity.customerData?.email
            ?.toLowerCase()
            .includes(lowerSearchTerm) ||
          activity.expertData?.email?.toLowerCase().includes(lowerSearchTerm) ||
          activity.status?.toLowerCase().includes(lowerSearchTerm) ||
          activity.customerData?.teamRole
            ?.toLowerCase()
            .includes(lowerSearchTerm)
      );
    }

    // Apply status filter
    if (filterCriteria.status && filterCriteria.status.trim() !== "") {
      filtered = filtered.filter((activity) => {
        if (filterCriteria.status === "completed") {
          return activity.status === "completed";
        } else if (filterCriteria.status === "active") {
          return activity.status === "active";
        } else if (filterCriteria.status === "issue-reported") {
          return activity.hasIssue === true;
        }
        return true;
      });
    }

    // Apply amount range filter for activities
    if (filterCriteria.amountRange && filterCriteria.amountRange.length > 0) {
      filtered = filtered.filter((activity) => {
        const activityAmount =
          parseFloat(activity.cost) ||
          parseFloat(activity.totalAmount) ||
          parseFloat(activity.amount?.replace("$", "")) ||
          0;
        return filterCriteria.amountRange.some((range) => {
          switch (range) {
            case "0-100":
              return activityAmount >= 0 && activityAmount <= 100;
            case "101-200":
              return activityAmount >= 101 && activityAmount <= 200;
            case "201-300":
              return activityAmount >= 201 && activityAmount <= 300;
            case "301-400":
              return activityAmount >= 301 && activityAmount <= 400;
            case "401-500":
              return activityAmount >= 401 && activityAmount <= 500;
            case "501+":
              return activityAmount > 500;
            default:
              return true;
          }
        });
      });
    }

    // Apply custom amount range filter for activities
    if (filterCriteria.customAmountMin || filterCriteria.customAmountMax) {
      filtered = filtered.filter((activity) => {
        const activityAmount =
          parseFloat(activity.cost) ||
          parseFloat(activity.totalAmount) ||
          parseFloat(activity.amount?.replace("$", "")) ||
          0;
        const min = parseFloat(filterCriteria.customAmountMin) || 0;
        const max = parseFloat(filterCriteria.customAmountMax) || Infinity;
        return activityAmount >= min && activityAmount <= max;
      });
    }

    // Apply rating filter
    if (filterCriteria.rating && filterCriteria.rating.trim() !== "") {
      const targetRating = parseInt(filterCriteria.rating);
      filtered = filtered.filter((activity) => {
        const activityRating = Math.floor(
          activity.customerRating || activity.rating || 0
        );
        return activityRating === targetRating;
      });
    }

    return filtered;
  };
  // Utility function to convert string to dd/mm/yyyy
  function formatDateToDDMMYYYY(dateString) {
    if (!dateString) return "";
    // Parse with Date constructor
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if parsing fails

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  // Handler for editing a member's profile (name and teamRole)
  const handleEditProfileSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editedMemberId) return;
    setSetupTeamLoading(true);
    try {
      // 1. Update profiles collection where userId == editedMemberId
      const profilesRef = collection(db, "profiles");
      const q = query(profilesRef, where("userId", "==", editedMemberId));
      const querySnapshot = await getDocs(q);
      for (const docSnap of querySnapshot.docs) {
        await updateDoc(docSnap.ref, {
          name: formData.fullName,
          teamRole: formData.role,
        });
      }
      // 2. Update users collection at users/editedMemberId
      const userRef = doc(db, "users", editedMemberId);
      await updateDoc(userRef, {
        name: formData.fullName,
        teamRole: formData.role,
        uiRole: formData.role,
      });
      // Optionally, show success notification or close modal
      setEditModel(false);
      setFormData({ fullName: "", email: "", role: "" });
      setEditedMemberId(null);
      // Optionally refresh team data
      // if (user?.orgId && user?.teamId) {
      //   dispatch(
      //     fetchAllTeamData({
      //       orgId: user.orgId,
      //       userId: user.teamId,
      //       currentId: user?.uid,
      //       userRole: user.uiRole || user?.teamRole,
      //     })
      //   );
      // }

      // Update Redux state immediately using the new action
      await dispatch(
        updateMemberAfterSave({
          memberId: editedMemberId,
          updatedData: {
            name: formData.fullName,

            role: formData.role,
          },
        })
      );
    } catch (error) {
      console.error("Error updating profile/user:", error);
      alert("Failed to update profile. Please try again.");
    } finally {
      setSetupTeamLoading(false);
    }
  };

  // Real-time listeners are now managed in App.tsx for background updates
  // Only apply filters when search term changes
  useEffect(() => {
    if (user?.uid && user?.orgId && user?.teamId && members.length > 0) {
      console.log('Applying search filter:', { searchTerm, teamId: user.teamId, userRole: user.uiRole || user.teamRole });
      dispatch(
        filterMembersTeams({
          searchTerm,
          userRole: user.uiRole || user.teamRole,
          userId: user.teamId, // Use teamId for proper team filtering
        })
      );
    }
  }, [dispatch, searchTerm, user?.uid, user?.orgId, user?.teamId, user?.uiRole, user?.teamRole, members.length]);

    // Setup specific current team listener for real-time team updates
    useEffect(() => {
      if (user?.orgId && user?.teamId) {
        dispatch(
          setupCurrentTeamListener({
            orgId: user.orgId,
            userId: user.teamId,
          })
        );
      }
  
      // Cleanup current team listener when dependencies change
      return () => {
        dispatch(cleanupCurrentTeamListener());
      };
    }, [dispatch, user?.orgId, user?.teamId]);
  
    // Log current team updates for debugging
    useEffect(() => {
      if (currentTeam) {
        console.log("Current team updated in real-time:", {
          id: currentTeam.id,
          teamName: currentTeam.teamName,
          users: currentTeam.users?.length || 0,
          updatedAt: currentTeam.updatedAt,
        });
      }
    }, [currentTeam]);

  // Fetch ratings for all team members when members data is loaded
  useEffect(() => {
    if (members && members.length > 0) {
      members.forEach((member) => {
        if (member.id || member.uid) {
          dispatch(
            fetchUserRatingAndReviews({
              userId: member.id || member.uid,
              role: "Customer",
            })
          );
        }
      });
    }
  }, [dispatch, members]);

  // Fetch ratings for all activity participants when activities are loaded
  useEffect(() => {
    if (teamActivities && teamActivities.length > 0) {
      teamActivities.forEach((activity) => {
        // Fetch expert ratings
        if (activity.expertId || activity.expertData?.id) {
          dispatch(
            fetchUserRatingAndReviews({
              userId: activity.expertId || activity.expertData.id,
              role: "Expert",
            })
          );
        }
        // Fetch customer ratings
        if (activity.customerId || activity.customerData?.id) {
          dispatch(
            fetchUserRatingAndReviews({
              userId: activity.customerId || activity.customerData.id,
              role: "Customer",
            })
          );
        }
      });
    }
  }, [dispatch, teamActivities]);

  return (
    <Layout>
      <div
        className="p-6 bg-white rounded-lg shadow"
        style={{
          height: "calc(100vh - 112px)",
          overflowY: "hidden",
            overflowX:'hidden'
        }}
      >
        <div className=" flex justify-between  mb-2">
          <div className="flex">
            {" "}
            <button
              className={`py-2 px-8 ${activeTab === "Directory"
                  ? "border-b-4 border-[#F15D18]  text-[16px] nunito-semibold text-[#F15D18]"
                  : "text-[#A8A8A8] text-[16px] nunito-semibold"
                }`}
              onClick={() => handleTabChange("Directory")}
            >
              Directory
            </button>
            <button
              className={`py-2 px-8 ${activeTab === "Activity"
                  ? "border-b-4 border-[#F15D18]  text-[16px] nunito-semibold text-[#F15D18]"
                  : "text-[#A8A8A8] text-[16px] nunito-semibold"
                }`}
              onClick={() => handleTabChange("Activity")}
            >
              Team Activity
            </button>
          </div>
          {activeTab === "Directory" && (
            <div className="flex items-center relative group">
              <span className="mr-4 text-[#696969] text-[16px] nunito-semibold">
                {/* Amount Distributed: ${totalDistributed.toFixed(2)} */}
              </span>
              <button
                className="bg-white  w-[168px] h-[40px] text-[#F15D18]  disabled:text-[#919191] disabled:border-[#919191]   disabled:cursor-not-allowed text-[14px] nunito-bold border-[1.4px] border-[#F15D18]  rounded-[8px] px-2 py-2 flex items-center"
                onClick={() => setDistributeFundModel(true)}
                disabled={!wallet?.balance}
              >
                {" "}
                {!wallet?.balance ? (
                  <>
                    {" "}
                    <img
                      src={teamIconDisabled}
                      alt="Distribute Funds"
                      className="w-[20px] h-[20px]  mr-2"
                    />
                  </>
                ) : (
                  <>
                    {" "}
                    <img
                      src={DistributeFunds}
                      alt="Distribute Funds"
                      className="w-[20px] h-[20px]  mr-2"
                    />
                  </>
                )}
                Distribute Funds
              </button>
              {/* Tooltip */}
              {!wallet?.balance && (
                <div className="absolute bottom-6 right-[-250px] transform -translate-x-1/2 mb-2 px-3 py-2 bg-white text-black text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                  Your wallet is empty.{" "}
                  {user?.teamRole === "customer_owner"
                    ? "Add balance"
                    : " Request funds"}{" "}
                  to start distributing money to your team
                </div>
              )}
            </div>
          )}
        </div>

        <div className="flex justify-between items-center mb-2">
          <h2 className="text-[20px] nunito-semibold text-[#696969]">
            {activeTab}
          </h2>
          <div className=" relative flex items-center">
            {activeTab === "Directory" &&
              user?.teamRole !== "customer_team_member" &&
              filteredMembers.length > 0 && (
                <button
                  className="bg-[#F15D18] w-[149px] h-[40px] text-white text-[14px] nunito-bold  px-4 rounded-[8px] flex items-center mr-6"
                  onClick={() => setAddMember(true)}
                >
                  <span className="mr-1">
                    <Plus className="w-[24px] h-[24px]" />
                  </span>{" "}
                  Add Member
                </button>
              )}{" "}
            <div className="relative">
              <input
                type="text"
                placeholder="Search"
                className=" pl-10 pr-4 py-2 border-[1.4px] border-[#EBEBEB] text-[#919191] text-[16px] nunito-regular  w-[215px] h-[40px] rounded-[8px]"
                value={
                  activeTab === "Directory" ? searchTerm : activitySearchTerm
                }
                onChange={(e) => {
                  if (activeTab === "Directory") {
                    setSearchTerm(e.target.value);
                  } else {
                    setActivitySearchTerm(e.target.value);
                  }
                }}
              />
              <Search className="absolute left-3 top-2 h-[24px] w-[24px] text-[#919191]" />
            </div>
            <div className="relative">
              <button
                className={`ml-4 p-2 w-[40px] h-[40px] border-[1.4px] border-[#EBEBEB] rounded-[8px] ${hasActiveFilters()
                    ? "bg-[#F15D18]"
                    : filterViewModel
                      ? "bg-[#EBEBEB]"
                      : ""
                  }`}
                onClick={() => setFilterViewModel(!filterViewModel)}
              >
                <Filter
                  className={`h-[24px] w-[24px] ${hasActiveFilters() ? "text-white" : "text-[#919191]"
                    }`}
                />
              </button>
            </div>
            <div className="relative group">

              <button className="ml-2 p-2  w-[40px] h-[40px] border-[1.4px] border-[#EBEBEB] rounded-[8px]">
                <Download className="h-[24px] w-[24px] text-[#919191]" />
              </button>
              <div className="absolute right-0 -top-8 px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-30" dir="rtl">
                !This feature is on its way - stay tuned
              </div>
            </div>
            {filterViewModel && (
              <FilterModelTeam
                sections={sections}
                setSections={setSections}
                customWallet={customWallet}
                setCustomWallet={setCustomWallet}
                customAmount={customAmount}
                setCustomAmount={setCustomAmount}
                setFilterViewModel={setFilterViewModel}
                onApplyFilters={handleApplyFilters}
                activeTab={activeTab}
                appliedFilters={filterCriteria}
              />
            )}
          </div>
        </div>
        {user?.teamRole === "customer_team_member" ? (
          <>
            {" "}
            <div className="flex flex-col items-center justify-center w-[608px] mt-10 p-10   mx-auto text-center">
              {/* Orange squares with circles */}
              <img src={teamRoleMemberimg} className="w-[324px] h-[279px]" />

              {/* Text */}
              <h2 className="text-[24px] nunito-semibold text-[#404040] mt-1 mb-6">
                Upgrade your plan to enjoy the benefits of adding and working
                with your team!
              </h2>

              {/* Button */}
              <button className="w-[93px] h-[40px] bg-[#F15D18]  px-2 py-2 rounded-[8px] text-[14px] text-[#FFFFFF] nunito-bold">
                Upgrade
              </button>
            </div>
          </>
        ) : (
          <>
            {" "}
            {activeTab === "Directory" ? (
              <>
                {" "}
                {(() => {
                  // Get filtered members based on applied filters
                  const membersToShow = getFilteredMembers();

                  // Pagination calculations for directory
                  const startIndex = (currentPage - 1) * itemsPerPage;
                  const endIndex = startIndex + itemsPerPage;
                  const paginatedMembers =
                    membersToShow?.slice(startIndex, endIndex) || [];
                  const totalDirectoryPages = Math.ceil(
                    (membersToShow?.length || 0) / itemsPerPage
                  );

                  return (
                    <>
                      <div className="bg-white rounded-[12px] border-[1px]  border-[#EBEBEB] overflow-hidden" style={{
          height: "calc(80vh - 135px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}>
                        <table className="min-w-full divide-y max-h-[751px] divide-gray-200  " >
                          <thead className="bg-[#FEF0EA]">
                            <tr>
                              <th className="px-3  py-3  text-[14px]  nunito-semibold text-[#404040]  tracking-wider">
                                Status
                              </th>
                              <th className="px-3 py-3 text-left flex items-center justify-between  text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Name
                              </th>
                              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Role
                              </th>
                              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Email
                              </th>
                              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Total Sessions
                              </th>
                              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Last Activity
                              </th>
                              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Wallet
                              </th>
                              <th className="px-3 py-3 text-left  text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Total Amount
                              </th>
                              <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040]  tracking-wider">
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody className="bg-white divide-y divide-gray-200">
                            {loading || filteredMembersLoading ? (
                              <tr>
                                <td colSpan={9} className="text-center py-10">
                                  <div className="flex justify-center items-center flex-col gap-2">
                                    <Loading />
                                    <p className="text-sm text-gray-500">
                                      {loading ? 'Loading team data...' : 'Filtering members...'}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            ) : paginatedMembers?.length > 0 ? (
                              paginatedMembers?.map((member) => (
                                <tr
                                  key={member.id}
                                  className={
                                    shouldHighlightRow(member)
                                      ? "bg-gray-100"
                                      : "bg-white"
                                  }
                                >
                                  <td className="px-3 py-3 whitespace-nowrap">
                                    <div className="flex items-center justify-center">
                                      <StatusIndicator
                                        status={
                                          member.userData?.disabled === true
                                            ? "deactivated"
                                            : member.userData?.disabled ===
                                              false
                                              ? "active"
                                              : member.status
                                        }
                                      />
                                    </div>
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap">
                                    <div className="flex items-center">
                                      {member.avatar ? (
                                        <img
                                          className="h-[38px] w-[38px] rounded-full"
                                          src={member.avatar}
                                          alt=""
                                        />
                                      ) : (
                                        <div className="flex-shrink-0 h-[38px] w-[38px] rounded-full bg-orange-500 flex items-center justify-center text-white">
                                          {member.initials}
                                        </div>
                                      )}
                                      <div className="ml-3">
                                        <div className="text-[14px] truncate max-w-40 font-medium text-[#696969]">
                                          {member.name}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap">
                                    <div className="text-[14px] nunito-regular text-[#696969]">
                                      {formatRole(
                                        member?.profileData?.teamRole ||
                                        member?.role
                                      )}
                                    </div>
                                  </td>
                                  <td className="px-3 py-3 whitespace-normal">
                                    <div className="text-[14px] nunito-regular truncate max-w-44 text-[#696969] flex flex-col">
                                      <span>{member.email.slice(0, 15)}</span>
                                      <span>{member.email.slice(15)}</span>
                                    </div>
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                    {member.sessions}
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                    {formatDateToDDMMYYYY(
                                      member.lastActivitycustomer ||
                                      "No activity"
                                    )}
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                    {member.wallet}
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                                    {member.totalSpent}
                                  </td>
                                  <td className="px-3 py-3 whitespace-nowrap text-left text-sm font-medium">
                                    <div className="flex space-x-3  justify-end">
                                      {member.status !== "invited" && (
                                        <button
                                          className=""
                                          onClick={() => handleEdit(member)}
                                        >
                                          <Pencil className="h-[20px] w-[20px] text-[#919191] hover:text-gray-500 stroke-[2px]  " />
                                        </button>
                                      )}
                                      <div className="relative group">

                                      <button className="">
                                        <Trash className="h-[20px] w-[20px] text-[#919191] hover:text-gray-500 stroke-[2px] " />
                                      </button>
                                         <div className="absolute right-0 -top-8 px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 whitespace-nowrap z-30" dir="rtl">
            !This feature is on its way - stay tuned
          </div>
                                      </div>
                                      <button
                                        className={`${member.status === "invited" ||
                                            member.status === "invited-send"
                                            ? "text-gray-400 cursor-not-allowed "
                                            : "text-[#F15D18] underline cursor-pointer"
                                          } text-[14px] nunito-semibold`}
                                        disabled={
                                          member.status === "invited" ||
                                          member.status === "invited-send"
                                        }
                                        onClick={() => handleView(member)}
                                      >
                                        View
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={9} className=" ">
                                  {(() => {
                                    // Check if filters are applied
                                    const filtersActive =
                                      hasActiveFilters() ||
                                      searchTerm.trim() !== "";

                                    // If filters/search are applied but no results found
                                    if (
                                      filtersActive &&
                                      members &&
                                      members.length > 0
                                    ) {
                                      return (
                                        <div className="flex flex-col items-center py-20">
                                          <div className="w-24 h-24 mb-4 flex items-center justify-center">
                                            <Search className="w-16 h-16 text-gray-400" />
                                          </div>
                                          <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                                            Opps! No matching records found.
                                          </h2>
                                          <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                                            Try changing the filters or search
                                            criteria to see more results!
                                          </p>
                                        </div>
                                      );
                                    }

                                    // Original empty states when no filters are applied
                                    if (currentTeam) {
                                      return (
                                        <div className="flex flex-col items-center py-20">
                                          <div className="bg-[#4BB847] border-gray-100 border-[10px] rounded-full p-4 flex items-center justify-center mb-4">
                                            <Check className="text-white w-[40px] h-[40px]" />
                                          </div>
                                          <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                                            Team setup is complete!
                                          </h2>
                                          <p className="text-[#696969] text-[16px] nunito-regular mb-4 text-center">
                                            Your team is ready to roll. Add
                                            members, assign roles, and unlock
                                            the full potential of seamless
                                            teamwork.
                                          </p>
                                          <button
                                            className="bg-[#F15D18] w-[149px] h-[40px] text-white text-[14px] nunito-bold px-4 rounded-[8px] flex items-center justify-center"
                                            onClick={() => setAddMember(true)}
                                          >
                                            <span className="mr-1">
                                              <Plus className="w-[20px] h-[20px]" />
                                            </span>
                                            Add Member
                                          </button>
                                        </div>
                                      );
                                    } else {
                                      return (
                                        <div className="flex flex-col items-center py-20">
                                          <img
                                            src={emtyimg}
                                            alt="Empty State"
                                            className="w-[444px] h-[227px] mb-4"
                                          />

                                          <button
                                            className="bg-[#F15D18] w-[150px] h-[40px] mt-2 rounded-[8px] text-[#FFFFFF] text-[14px] nunito-bold"
                                            onClick={handleSetupTeamClick}
                                          >
                                            Set up your Team
                                          </button>
                                          <p className=" text-[16px] nunito-regular mt-4  text-[#696969]">
                                            Create your team, invite members,
                                            and lead the way - it all starts
                                            with you!
                                          </p>
                                        </div>
                                      );
                                    }
                                  })()}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination for Directory */}
                      {totalDirectoryPages > 1 && (
                        <div className="py-3 flex items-center justify-center">
                          <nav className="flex space-x-1">
                            {[...Array(totalDirectoryPages)].map((_, index) => (
                              <button
                                key={index + 1}
                                onClick={() => handlePageChange(index + 1)}
                                className={`px-2 py-1 text-[#696969] ${currentPage === index + 1
                                    ? "bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border"
                                    : ""
                                  }`}
                              >
                                {String(index + 1).padStart(2, "0")}
                              </button>
                            ))}
                          </nav>
                        </div>
                      )}
                    </>
                  );
                })()}
              </>
            ) : (
              <ActivityTable />
            )}
          </>
        )}
      </div>
      {/* directory view model */}
      {profileViewModel && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-[24px] w-[554px] shadow-lg   p-4">
            <div className="text-right">
              <button
                onClick={onClose}
                className="text-[#696969] hover:text-gray-700"
              >
                <X className="w-[32px] h-[32px] stroke-[2px]" />
              </button>
            </div>
            <div className=" relative border-[1px] border-[#C4C4C4] mb-3  rounded-[16px] p-4">
              <div className=" text-[20px] truncate max-w-36 nunito-semibold text-[#0A0A0A] absolute top-4 right-4">
                {orgData?.teamName || ""}
              </div>
              <div className="flex items-center space-x-4 mb-6  relative">
                <div className="relative flex justify-center">
                  {profileData?.profileData?.profileImageUrl ? (
                    <img
                      src={profileData.profileData.profileImageUrl}
                      alt="Customer profile"
                      className="w-[80px] h-[80px] rounded-[16px] object-cover"
                      style={{
                        boxShadow:
                          "0px 2px 4px 0px rgba(241, 93, 24, 0.25), 0px -2px 4px 0px rgba(241, 93, 24, 0.25), 2px 0px 4px 0px rgba(241, 93, 24, 0.25), -2px 0px 4px 0px rgba(241, 93, 24, 0.25)",
                      }}
                    />
                  ) : (
                    getInitialsImage(profileData?.name)
                  )}
                  {selectedMemberForEdit?.userData?.disabled === true ? (
                    <span className="bg-[#FFE1E0] text-[#D5332A] px-2 py-1  flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Deactivated
                    </span>
                  ) : selectedMemberForEdit?.status === "invited" ||
                    selectedMemberForEdit?.userData?.disabled === undefined ? (
                    <span className="bg-[#FFF8CC] text-[#D9A41C] px-2 py-1 flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Invite sent
                    </span>
                  ) : (
                    <span className="bg-[#CBF3C9] text-[#1B8717] px-2 py-1  flex items-center justify-center rounded-[16px] text-[12px] absolute bottom-0 transform translate-y-1/2">
                      Active
                    </span>
                  )}
                </div>
                <div className="flex-1">
                  {" "}
                 <div className="group relative inline-block    ">
                    <span className=" text-[#0A0A0A] truncate  text-[24px] nunito-semibold ">
                                  {profileData?.name?.length > 20 
    ? `${profileData.name.slice(0, 20)}...` 
    : profileData?.name || ""}
                    </span>
                    
                    {/* Tooltip on hover */}
                    <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-7  px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                      <div className="text-start">
                        <div className="  mb-1">
                          {profileData?.name}

                          
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="group relative ">

                  <p className="text-[#404040] truncate max-w-80 text-[14px] nunito-medium">
                    {profileData?.email || ""}
                  </p>
                    {/* Tooltip on hover */}
                    <div className="absolute z-10 opacity-0 group-hover:opacity-100 top- bottom-5  px-2 py-1 bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] text-xs rounded-[8px] shadow-lg transition-opacity duration-200 pointer-events-none">
                      <div className="text-start">
                        <div className="  mb-1">
                          {profileData?.email}

                          
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {" "} <span className="text-[#696969] text-[14px] nunito-medium">
                      ({formatRole(profileData?.profileData?.teamRole)})
                    </span>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <Star className="w-[20px] h-[20px] fill-[#F5A038] text-[#F5A038]" />
                      <span className="text-[#696969] text-[14px] nunito-regular">
                        {ratingsLoading[profileData?.userData?.uid]
                          ? ""
                          : userRatings[
                            profileData?.userData?.uid
                          ]?.avgRating?.toFixed(1) || "0.0"}
                      </span>
                      <span className="text-[#696969] text-[14px] nunito-regular ml-1">
                        (
                        {ratingsLoading[profileData?.userData?.uid]
                          ? ""
                          : userRatings[profileData?.userData?.uid]
                            ?.totalReviews || "0"}{" "}
                        reviews)
                      </span>
                    </div>
                    <div className="text-[#696969] flex items-center">
                      <Clock className="w-[14px] text-[#696969] h-[14px]" />
                      <span className="text-[14px] text-[#404040] nunito-regular ml-1">
                        {profileData?.lastActive || ""}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-4  pt-2 px-">
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium ">
                    Total Sessions
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    {profileData.totalSessions}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Wallet Balance
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    ${profileData.walletBalance}
                  </p>
                </div>
                <div>
                  <p className="text-[#696969] text-[16px] nunito-medium">
                    Total Amount
                  </p>
                  <p className="nunito-bold text-[#F15D18] text-[20px]">
                    ${profileData.totalAmount}
                  </p>
                </div>
              </div>

              <div className="text-right mt-2">
                <button
                  className="text-[#696969]"
                  onClick={() => handleEdit(selectedMemberForEdit)}
                >
                  <Pencil className="h-[24px] w-[24px] text-[#696969]" />
                </button>
              </div>
            </div>
            {/* asana */}
            <div className="flex items-center  p-4  bg-white rounded-[16px]   border-[1px] border-[#C4C4C4] relative">
              {/* Logo/Icon */}
              <div className="mr-2">
                <Building2 className="w-[80px] h-[80px] stroke-[0.5px] text-[#000000]" />
              </div>
              {/* Text Content */}
              <div className="flex-grow">
                <div className="flex justify-between items-start">
                  <h2 className="text-[20px] nunito-semibold text-[#0A0A0A]">
                    {orgData?.name}
                  </h2>
                  <div className="flex items-center text-[#404040] text-[12px]">
                    <NotepadText className="w-[16px] h-[16px] mr-1 text-[#7B7B7B]" />
                    <span className=" flex text-[#404040] text-[12px]">
                      Tax ID: {orgData?.taxId || "N/A"}
                    </span>
                  </div>
                </div>
                <div className=" ">
                  <p className="text-[14px] nunito-medium text-[#404040] mt-">
                    Website: {orgData?.url || "N/A"}
                  </p>
                  <p className="text-[14px] nunito-medium  text-[#404040] mt-">
                    Address:    {orgData?.billingAddress
                      ? `${orgData.billingAddress.address_1 || ""}, ${orgData.billingAddress.address_2 || ""
                      }, ${orgData.billingAddress.city || ""}, ${getStateFullName(
                        orgData.billingAddress.country || "",
                        orgData.billingAddress.state || ""
                      )
                      }, ${getCountryFullName(orgData.billingAddress.country || "")}, ${orgData.billingAddress.postcode || ""
                      }`
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {EditeModel && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
            <div className="bg-white rounded-[24px] shadow-lg w-[448px]  ">
              <div className="flex justify-between items-center px-6 py-4 ">
                <h2 className="text-[24px] text-[#0A0A0A] nunito-semibold">
                  Edit
                </h2>
                <button
                  onClick={handleClose}
                  className="text-[#696969] hover:text-gray-700"
                >
                  <X className="h-[32px] w-[32px] " />
                </button>
              </div>
              <form onSubmit={handleEditProfileSubmit} className="px-6">
                <div className="p-5 border-[1px] rounded-[16px] border-[#C4C4C4] mx-4 ">
                  <div className="mb-6 flex justify-start">
                    <div className="relative">
                      <div className="w-[80px] h-[80px] rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                        {selectedMemberForEdit?.profileData?.profileImageUrl ? (
                          <img
                            src={selectedMemberForEdit?.profileData?.profileImageUrl}
                            alt="Profile"
                            className="w-full h-full rounded-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-[#F15D18] rounded-full flex items-center justify-center text-white text-xl font-bold">
                            {selectedMemberForEdit?.profileData?.name
                              ?.split(" ")
                              .map((part: string) => part.charAt(0).toUpperCase())
                              .join("") || "U"}
                          </div>
                        )}
                      </div>
                      <label className="absolute bottom-0 right-0 bg-[#F15D18] text-white p-1 disabled:cursor-not-allowed rounded-full cursor-pointer">
                        <Camera className="w-4 h-4" />
                        <input
                          type="file"
                          className="hidden"
                          accept="image/*"
                          onChange={handleImageUpload}
                          disabled={uploadingImage}
                        />
                      </label>
                      {uploadingImage && (
                        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full">
                          <Loader
                            className="animate-spin text-white"
                            size={24}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex items-center mb-4">
                    <h1 className="text-[20px] mr-4 text-[#404040] nunito-semibold">
                      Account Status
                    </h1>
                    <span className="font-medium mr-3">
                      {selectedMemberForEdit?.userData?.disabled === true
                        ? "Deactivated"
                        : selectedMemberForEdit?.userData?.disabled === false
                          ? "Active"
                          : statusLoading
                            ? "Loading..."
                            : "Unknown"}
                    </span>
                    <div
                      className={`relative w-12 h-6 rounded-full ${selectedMemberForEdit?.userData?.disabled === true
                          ? "bg-gray-300"
                          : "bg-green-500"
                        } cursor-pointer`}
                      onClick={() =>
                        handleAccountStatusToggle(
                          selectedMemberForEdit?.id ||
                          selectedMemberForEdit?.uid,
                          selectedMemberForEdit?.userData?.disabled === true
                        )
                      }
                      style={{ opacity: statusLoading ? 0.5 : 1 }}
                    >
                      <div
                        className={`absolute top-1 h-4 w-4 rounded-full bg-white transition-all ${selectedMemberForEdit?.userData?.disabled === true
                            ? "left-1"
                            : "left-7"
                          }`}
                      ></div>
                    </div>
                  </div>
                  <div className="mb-5">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Full Name
                    </label>
                    <input
                      type="text"
                      placeholder="Enter full name"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      disabled={setupTeamLoading}
                      className="w-full px-3 py-2 border-[1px] border-[#696969] text-[#404040] rounded-[6px] text-[14px] nunito-normal"
                    />
                  </div>

                  <div className="mb-5">
                    <label className="block text-[16px] text-[#404040] nunito-semibold mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter email"
                      value={formData.email}
                      onChange={handleChange}
                      disabled
                      className="w-full px-3 py-2 border-[1px] border-[#696969] text-[#404040] text-[14px] nunito-normal rounded-[6px]"
                    />
                  </div>

                  <div className="mb-2">
                    <label className="block text-[#404040] text-[16px] nunito-semibold mb-1">
                      Role
                    </label>
                    <div className="relative">
                      <select
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        disabled={setupTeamLoading}
                        className="w-full px-3 py-2 border-[1px] text-[14px] nunito-normal  border-[#696969] rounded-[6px] appearance-none"
                      >
                        <option value="customer_team_lead">Team Lead</option>

                        <option value="customer_team_member">
                          Team Member
                        </option>
                      </select>{" "}
                      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                        {isDropdownOpen ? (
                          <ChevronUp className="w-4 h-4" />
                        ) : (
                          <ChevronDown className="w-4 h-4" />
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="px-6 py-4 flex justify-center">
                  <button
                    type="submit"
                    className="bg-[#F15D18] w-[120px] h-[40px] hover:bg-orange-600 text-[16px] nunito-semibold text-white px-8 py-2 rounded-[8px] transition-colors flex items-center justify-center"
                    disabled={setupTeamLoading}
                  >
                    {setupTeamLoading ? (
                      <Loader className="animate-spin mr-2" size={20} />
                    ) : null}
                    {setupTeamLoading ? "Saving..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
      {addMember && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          {" "}
          <div className="bg-white rounded-2xl shadow-lg w-[379px]  max-w-md p-6 relative">
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={handleAddMemberClose}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            <h2 className="text-xl font-medium text-[#101828] mb-4">
              Add Member
            </h2>

            <p className="text-[#344054] mb-3">
              Enter email address to send the invitation link.
            </p>

            <form onSubmit={handleInviteMember}>
              <div className="mb-4">
                {/* Display general error message */}
                {formErrors.general && (
                  <div className="mb-1  ">
                    <p className="text-red-600 text-[14px] nunito-medium">
                      {formErrors.general}
                    </p>
                  </div>
                )}
                <label
                  htmlFor="email"
                  className="block text-[16px] font-medium text-[#404040] mb-1"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter email"
                  required
                  disabled={isInviting}
                  className={`w-full text-[#404040] text-[14px] nunito-normal px-3 py-2 border ${formErrors.general ? "border-[#D5332A]" : "border-[#D7DEDD]"
                    } rounded-md focus:outline-none focus:ring-2  text-[#404040] focus:ring-[#696969] focus:border-[#696969]`}
                  value={inviteFormData.email}
                  onChange={handleInviteFormChange}
                />
                {formErrors.email && (
                  <p className="text-[#D5332A] text-xs mt-1">
                    Email is required
                  </p>
                )}
              </div>

              <div className="mb-6">
                <label
                  htmlFor="role"
                  className="block text-[16px] font-medium text-[#404040] mb-1"
                >
                  Role
                </label>
                <div className="relative " ref={dropdownRef}>
                  <button
                    type="button"
                    className={`w-full p-2 border rounded-[8px] text-left text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500 flex justify-between items-center transition-colors ${formErrors.role
                        ? "border-[#D5332A] bg-red-50"
                        : "border-[#D9D9D9] hover:border-[#696969]"
                      }`}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    disabled={isInviting}
                    aria-expanded={isDropdownOpen}
                    aria-haspopup="listbox"
                    aria-labelledby="role-label"
                  >
                    <span
                      className={`text-[14px] nunito-normal ${inviteFormData.role
                          ? "text-[#404040]"
                          : "text-[#919191]"
                        }`}
                    >
                      {(() => {
                        if (!inviteFormData.role) return "Select role";

                        // If user is customer_owner, show the selected role
                        if (user?.teamRole === "customer_owner") {
                          return inviteFormData.role === "teamLead"
                            ? "Team Lead"
                            : "Team Member";
                        }

                        // For non-owners, always show Team Member
                        return "Team Member";
                      })()}
                    </span>
                    <svg
                      className={`w-4 h-4 ml-2 transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""
                        }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>

                  {isDropdownOpen && (
                    <div
                      className="absolute z-10 mt-1 w-full bg-white border border-[#696969] rounded-[8px] shadow-lg max-h-48 overflow-y-auto"
                      role="listbox"
                      aria-labelledby="role-label"
                    >
                      {user?.teamRole === "customer_owner" && (
                        <div
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-[14px] nunito-normal text-[#404040] transition-colors"
                          onClick={() => {
                            handleInviteFormChange({
                              target: { id: "role", value: "teamLead" },
                            });
                            setIsDropdownOpen(false);
                          }}
                          role="option"
                          aria-selected={inviteFormData.role === "teamLead"}
                        >
                          <div className="flex items-center justify-between">
                            <span>Team Lead</span>
                            {inviteFormData.role === "teamLead" && (
                              <svg
                                className="w-4 h-4 text-[#F15D18]"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                      )}

                      <div
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-[14px] nunito-normal text-[#404040] transition-colors"
                        onClick={() => {
                          handleInviteFormChange({
                            target: { id: "role", value: "teamMember" },
                          });
                          setIsDropdownOpen(false);
                        }}
                        role="option"
                        aria-selected={inviteFormData.role === "teamMember"}
                      >
                        <div className="flex items-center justify-between">
                          <span>Team Member</span>
                          {inviteFormData.role === "teamMember" && (
                            <svg
                              className="w-4 h-4 text-[#F15D18]"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {formErrors.role && (
                  <p className="text-[#D5332A] text-xs mt-1">
                    Role is required
                  </p>
                )}
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  className={`bg-[#F15D18] hover:bg-orange-600 text-white px-6 py-2 rounded-md font-medium transition-colors ${!isInviteFormValid || isInviting
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                    }`}
                  disabled={!isInviteFormValid || isInviting}
                >
                  {isInviting ? "Processing..." : "Invite"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {inviteSuccess && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[450px]   p-6 relative text-center shadow-lg">
            {/* Close Button */}
            <button
              onClick={() => setInviteSuccess(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X className="w-[32px] h-[32px]" />
            </button>

            {/* Check Icon */}
            <div className="flex justify-center mt-1">
              <div className="bg-[#4BB847] border-gray-100 border-[10px] rounded-full p-4 flex items-center justify-center">
                <Check className="text-white w-[65px] h-[65px]" />
              </div>
            </div>
            <div className=" flex justify-center ">
              {/* Success Message */}
              <p className="  text-[#404040] w-[280px] text-[24px] mt-1 nunito-semibold">
                Team Member Successfully Added
              </p>
            </div>
            <button
              className="bg-[#F15D18] mt-2  w-[118px] text-[#FFFFFF] nunito-semibold h-[44px] text-[18px] rounded-md"
              onClick={() => {
                setInviteSuccess(false);
                setAddMember(true);
              }}
            >
              Add More
            </button>
          </div>
        </div>
      )}{" "}
      {distributeFundModel && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          {!showDistributeForm ? (
            <div className="bg-white rounded-3xl shadow-lg w-[468px] max-w-md  px-4 pt-3 relative">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-[24px] nunito-semibold text-[#0A0A0A]">
                  Distribute Funds
                </h2>
                <button
                  className="text-[#696969] hover:text-gray-700 "
                  onClick={handleDistributeFundsClose}
                >
                  <X className="w-[32px] h-[32px] stroke-[2px] " />
                </button>
              </div>

              <div className="relative border-[1px] border-[#D9D9D9] p-3 rounded-[16px]" ref={dropdownMembersRef} >
                <label className="text-[#404040] text-[16px] nunito-semibold ">
                  Member/Members
                </label>

                <div
                  className="border-[1px] border-[#696969] mt-1 rounded-[6px] p-3 cursor-pointer flex justify-between items-center"
                  onClick={toggleDropdown} 
                >
                  <span className="text-[#404040] text-[14px] nunito-normal">
                    {selectedMembers.length === 0
                      ? "Select Members"
                      : `${selectedMembers.length} Member(s) Selected`}
                  </span>
                  <ChevronDown
                    className={`h-[16px] w-[16px] text-[#919191] transform transition-transform ${isDropdownOpen ? "rotate-180" : ""
                      }`}
                  />
                </div>

                {isDropdownOpen && (
                  <div className="absolute top-full left-0 right-0 mt-1 border border-[#696969] rounded-md bg-white shadow-lg max-h-48 overflow-y-auto">
                    {filteredMembers
                      ?.filter((d) => !d.isOwner && d.status !== "invited")
                      .map((member) => (
                        <div
                          key={member.id}
                          className="flex items-center px-3 py-2 hover:bg-gray-100"
                        >
                          <input
                            type="checkbox"
                            id={`member-${member.id}`}
                            checked={selectedMembers.includes(
                              member.id.toString()
                            )}
                            onChange={() =>
                              handleMemberSelect(member.id.toString())
                            }
                            className="h-[16px] w-[16px] text-[#F15D18] accent-[#F15D18] rounded-[2px] border-gray-300 focus:ring-[#F15D18]"
                          />
                          <label
                            htmlFor={`member-${member.id}`}
                            className="ml-2 text-[#404040] text-[14px] nunito-semibold  cursor-pointer flex-1"
                          >
                            {member.name}
                          </label>
                        </div>
                      ))}
                  </div>
                )}
              </div>

              <div className="flex justify-center mt-4 mb-4">
                <button
                  type="button"
                  className="bg-[#F15D18] w-[120px] h-[40px] hover:bg-orange-600 text-[#FFFFFF] px-8 py-2 rounded-[8px] text-[16px] nunito-bold"
                  disabled={selectedMembers.length === 0}
                  onClick={() => setShowDistributeForm(true)}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-white rounded-[24px] shadow-lg w-full max-w-md mx-auto">
              <div className="flex items-center p-4">
                <button
                  onClick={() => setShowDistributeForm(false)}
                  className="mr-2"
                >
                  <ArrowLeft className="w-[32px] h-[32px] text-[#696969] stroke-[2px]" />
                </button>
                <h2 className="text-[24px] nunito-semibold flex-grow text-[#0A0A0A]">
                  Distribute Funds
                </h2>
                <button onClick={handleDistributeFundsClose}>
                  <X className="w-[32px] h-[32px] text-[#696969] stroke-[2px]" />
                </button>
              </div>

              <div className="p-4 mx-4 border border-[1x] rounded-[16px] border-[#D9D9D9]">
                <div className="mb-4">
                  <label className="block text-[16px] nunito-semibold mb-2 text-[#0A0A0A]">
                    Members added
                  </label>
                  <div className="grid grid-cols-3 gap-2">
                    {selectedMembers.map((memberId) => {
                      const member = filteredMembers?.find(
                        (m) => m.id.toString() === memberId
                      );
                      return (
                        <div key={memberId} className="flex items-center">
                          <div className="w-[16px] h-[16px] rounded-[2px] flex items-center justify-center mr-2 bg-[#F15D18]">
                            <Check size={16} className="text-white" />
                          </div>
                          <span className="text-[#404040] text-[14px] nunito-semibold">
                            {member?.name}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="mb-3">
                  <label className="block text-[16px] text-[#404040] nunito-semibold mb-1">
                    Amount
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      className={`w-full p-2 border-[1px] border-[#C4C4C4] text-[#404040] text-[14px] nunito-normal rounded-[6px] ${!validateDistributeAmount(distributeAmount)
                          ? "border-[#F55A51]"
                          : ""
                        }`}
                      disabled={distributing}
                      placeholder="Enter Amount"
                      value={distributeAmount}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d.]/g, "");
                        setDistributeAmount(value);
                      }}
                    />
                    {!validateDistributeAmount(distributeAmount) && (
                      <p className="text-[#D5332A] nunito-normal text-[10px] mt-1">
                        Insufficient Balance. $
                        {distributionMethod === "split"
                          ? (
                            Number(distributeAmount) - (wallet?.balance || 0)
                          ).toFixed(2)
                          : (
                            Number(distributeAmount) *
                            selectedMembers.length -
                            (wallet?.balance || 0)
                          ).toFixed(2)}{" "}
                        needed. To quickly{" "}
                        {user?.teamRole === "customer_owner"
                          ? "add balance"
                          : "request funds"}
                        , please{" "}
                        <button
                          className="text-[10px] nunito-bold  underline border-[#D5332A] text-[#D5332A]"
                          onClick={handleShowBalanceAdditionForm}
                        >
                          {showBalanceAdditionForm ? "hide form" : "click here"}
                        </button>
                      </p>
                    )}
                  </div>
                </div>

                {showBalanceAdditionForm && (
                  <div className="bg-white rounded-[16px] border-[1px] border-[#D9D9D9] mt-2 p-2">
                    {/* Add close button for the balance addition form */}
                    <div className="flex justify-end mb-2">
                      <button
                        onClick={handleCloseBalanceForm}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    </div>

                    {user?.teamRole === "customer_owner" ? (
                      <>
                        {!showSuccess ? (
                          <>
                            <div className="px-3 pt-2">
                              <label className="block text-[16px] nunito-semibold text-[#404040]">
                                Add Balance
                              </label>
                              <input
                                type="number"
                                placeholder="Enter Amount"
                                value={inputAmount}
                                disabled={isProcessingBalance}
                                onChange={(e) => setInputAmount(e.target.value)}
                                className="w-full p-2 border-[#C4C4C4] border-[1px] text-[#404040] nunito-normal text-[14px] rounded-[6px] mt-1"
                              />
                            </div>
                            <div className="justify-center flex">
                              <button
                                className="w-[120px] h-[40px] mt-3 mb-2 bg-[#F15D18] text-white py-2 rounded-[8px] text-[16px] nunito-bold"
                                onClick={() => handleAddBalance(inputAmount)}
                                disabled={isProcessingBalance}
                              >
                                {isProcessingBalance
                                  ? "Processing..."
                                  : "Submit"}
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="bg-white p-2">
                            <div className="flex justify-end mb-2">
                              {/* <button
                                onClick={handleResetBalanceAdditionForm}
                                className="text-gray-500 hover:text-gray-700"
                              >
                                <X className="w-5 h-5 text-gray-500" />
                              </button> */}
                            </div>
                            <div className="flex justify-center">
                              <div className="bg-[#4BB847] border-gray-100 border-[5px] rounded-full p-3 flex items-center justify-center">
                                <Check className="text-white w-[25px] h-[25px]" />
                              </div>
                            </div>
                            <div>
                              <p className="text-[14px] nunito-semibold text-[#F15D18] mt-4 text-center">
                                ${addedAmount}.00
                              </p>
                              <p className="text-[#404040] text-[14px] nunito-semibold text-center">
                                Successfully Added
                              </p>
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {!showSuccess ? (
                          <div>
                            {" "}
                            <div className="mb-4 p-4">
                              <label className="text-sm font-medium text-[#404040]">
                                Request Funds
                              </label>
                              <input
                                type="number"
                                placeholder="Enter Amount"
                                value={requestAmount}
                                onChange={(e) =>
                                  setRequestAmount(e.target.value)
                                }
                                disabled={isProcessing}
                                className="mt-1 w-full border border-gray-300 text-[#404040] rounded-lg p-2 focus:ring-2  focus:outline-none"
                                min="0"
                              />
                              {requestAmount && Number(requestAmount) <= 0 && (
                                <p className="text-red-500 text-sm mt-1">
                                  Amount must be greater than 0
                                </p>
                              )}
                            </div>
                            <div className="flex justify-center">
                              <button
                                className="w-[120px] bg-[#F15D18] hover:bg-orange-600 text-white py-2 rounded-lg font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed"
                                onClick={handleSendRequest}
                                disabled={
                                  isProcessing ||
                                  !requestAmount ||
                                  Number(requestAmount) <= 0
                                }
                              >
                                {isProcessing ? "Processing..." : "Send"}
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="flex flex-col items-center">
                              <button
                                className="absolute top-[75px] right-3"
                                onClick={handleCloseBalanceForm}
                              >
                                <X className="w-5 h-5 text-gray-500" />
                              </button>
                              <div className="p-3">
                                <MailCheck className="w-20 h-20 text-[#696969] stroke-[1px]" />
                              </div>
                              <h1 className="text-orange-500 text-3xl font-semibold">
                                ${Number(requestAmount).toFixed(2)}
                              </h1>
                              <h1 className="text-gray-800 text-2xl mt-2">
                                Request Successfully Sent
                              </h1>
                              <p className="text-gray-500 text-sm mt-2">
                                Wallet will be updated after team owner approves
                              </p>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}

                {selectedMembers.length > 1 && (
                  <div>
                    <div className="flex items-start mb-3">
                      <div
                        className="mt-1 w-5 h-5 rounded-full flex items-center justify-center mr-2 cursor-pointer"
                        onClick={() => setDistributionMethod("split")}
                      >
                        <div
                          className={`w-3 h-3 rounded-full ${distributionMethod === "split"
                              ? "bg-[#F26C2D] border border-gray-300"
                              : "border border-gray-300"
                            }`}
                        />
                      </div>
                      <div>
                        <p className="text-[#404040] nunito-medium w-[376px]">
                          Split ${distributeAmount || "{AMOUNT}"} equally to all
                          selected members, $
                          {distributeAmount && selectedMembers.length
                            ? (
                              Number(distributeAmount) /
                              selectedMembers.length
                            ).toFixed(2)
                            : "{PARTIAL_AMOUNT}"}{" "}
                          to each
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <div
                        className="mt-1 w-5 h-5 rounded-full flex items-center justify-center mr-2 cursor-pointer"
                        onClick={() => setDistributionMethod("distribute")}
                      >
                        <div
                          className={`w-3 h-3 rounded-full ${distributionMethod === "distribute"
                              ? "bg-[#F26C2D] border border-gray-300"
                              : "border border-gray-300"
                            }`}
                        />
                      </div>
                      <div>
                        <p className="text-[#404040] nunito-medium">
                          Distribute ${distributeAmount || "{AMOUNT}"} to each
                          member, $
                          {distributeAmount && selectedMembers.length
                            ? (
                              Number(distributeAmount) *
                              selectedMembers.length
                            ).toFixed(2)
                            : "{TOTAL_AMOUNT}"}{" "}
                          total distributed amount
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="flex justify-center mb-4">
                <button
                  className="w-[120px] h-[40px] mt-4 bg-[#F15D18] text-[16px] nunito-bold text-white py-2 rounded-md"
                  disabled={
                    !validateDistributeAmount(distributeAmount) || distributing
                  }
                  onClick={handleDistribute}
                >
                  {distributing ? "Processing..." : "Send"}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      {showDistributionSuccess && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg w-[450px]  p-6 relative text-center shadow-lg">
            {/* Close Button */}
            <button
              onClick={() => setShowDistributionSuccess(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X className="w-[32px] h-[32px]" />
            </button>

            {/* Check Icon */}
            <div className="flex justify-center mt-1">
              <div className="bg-[#4BB847] border-gray-100 border-[10px] rounded-full p-4 flex items-center justify-center">
                <Check className="text-white w-[80px] h-[80px]" />
              </div>
            </div>
            <div className="">
              {/* Amount */}
              <p className="text-[32px] nunito-semibold text-[#F15D18] mt-4">
                ${distributedAmount.toFixed(2)}
              </p>

              {/* Success Message */}
              <p className="text-[#404040] text-[32px] mt-1 nunito-semibold">
                Successfully Distributed
              </p>
            </div>
          </div>
        </div>
      )}
      {/* setup team model */}{" "}
      {setupTeamModel && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto p-4 px-6 relative">
            <div className="flex justify-between items-center mb-3 sticky top-0 bg-white pb-3 border-b border-gray-100">
              <h2 className="text-[24px] text-[#0A0A0A] nunito-semibold">
                Setup Team
              </h2>
              <button
                className="text-[#344054] hover:text-gray-700"
                onClick={handleClose}
              >
                <X className="w-[20px] h-[20px]" />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="space-y-3 pt-3">
                <div>
                  <h3 className="text-[16px] text-[#0A0A0A] nunito-semibold mb-4">
                    Organization Details
                  </h3>{" "}
                  {loadingOrgData ? (
                    <div className="flex justify-center items-center py-8">
                      <Loader
                        className="animate-spin text-[#F15D18] mr-2"
                        size={20}
                      />
                      <span className="text-[#696969] text-[14px]">
                        Loading organization details...
                      </span>
                    </div>
                  ) : (
                    <>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Organization Name
                          </label>
                          <input
                            type="text"
                            name="orgName"
                            placeholder="Enter Organization Name"
                            value={formData.orgName}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>

                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Organization URL
                          </label>
                          <input
                            type="text"
                            name="orgUrl"
                            placeholder="Enter Organization URL"
                            value={formData.orgUrl}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                          Tax ID (Used for Invoicing)
                        </label>
                        <input
                          type="text"
                          name="taxId"
                          placeholder="Enter Tax ID"
                          value={formData.taxId}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                          Address Line 1
                        </label>
                        <input
                          type="text"
                          name="addressLine1"
                          placeholder="Enter Address Line 1"
                          value={formData.addressLine1}
                          onChange={handleChange}
                          required
                          className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                          Address Line 2
                        </label>
                        <input
                          type="text"
                          name="addressLine2"
                          placeholder="Enter Address Line 2 (Optional)"
                          value={formData.addressLine2}
                          onChange={handleChange}
                          className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                        />
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Country
                          </label>
                          <div className="relative">
                            <select
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                              required
                              className="w-full px-3 py-2 border border-[#D9D9D9] rounded-[8px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                            >
                              <option value="">Select country</option>
                              {Array.isArray(countries) &&
                                countries.map((country) => (
                                  <option
                                    key={country.shortName || country.code}
                                    value={country.shortName || country.code}
                                  >
                                    {country.name}
                                  </option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-[16px] h-[16px] text-[#696969]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>

                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            State
                          </label>
                          <div className="relative">
                            <select
                              name="state"
                             value={getStateFullName(
                                                             formData.country || " ",
                                                             formData.state || " "
                                                           )}
                              onChange={handleChange}
                              disabled={
                                !formData.country ||
                                !Array.isArray(states) ||
                                states.length === 0
                              }
                              required
                              className="w-full px-3 py-2 border border-[#D9D9D9] rounded-[8px] text-[#404040] text-[14px] nunito-normal appearance-none focus:outline-none focus:ring-2 focus:ring-orange-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                            >
                              <option value="">
                                {!formData.country
                                  ? "Select country first"
                                  : "Select state"}
                              </option>
                              {Array.isArray(states) &&
                                states.map((state, index) => (
                                  <option key={index} value={state}>
                                    {state}
                                  </option>
                                ))}
                            </select>
                            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                              <svg
                                className="w-[16px] h-[16px] text-[#696969]"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 9l-7 7-7-7"
                                ></path>
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-3">
                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            City
                          </label>
                          <input
                            type="text"
                            name="city"
                            placeholder="Enter City"
                            value={formData.city}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>

                        <div>
                          <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                            Zip Code
                          </label>
                          <input
                            type="text"
                            name="zipCode"
                            placeholder="Enter Zip Code"
                            value={formData.zipCode}
                            onChange={handleChange}
                            required
                            className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
                <div>
                  <h3 className="text-[16px] text-[#0A0A0A] nunito-semibold mb-2">
                    Team Details
                  </h3>

                  <div className="mb-4">
                    <label className="block text-[16px] nunito-semibold text-[#404040] mb-1">
                      Team Name
                    </label>
                    <input
                      type="text"
                      name="teamName"
                      placeholder="Enter Team Name"
                      value={formData.teamName}
                      onChange={handleChange}
                      required
                      className="w-full px-3 py-2 border border-[#D7DEDD] rounded-[6px] text-[#404040] text-[14px] nunito-normal focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>
                </div>{" "}
                <div className="flex justify-center">
                  <button
                    type="submit"
                    disabled={setupTeamLoading}
                    className={`px-6 py-2 w-[95px] h-[44px] text-white text-[18px] nunito-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 flex items-center justify-center ${setupTeamLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#F15D18] hover:bg-orange-600"
                      }`}
                  >
                    {setupTeamLoading ? (
                      <Loader className="animate-spin w-5 h-5" />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}{" "}
      {viewModelOpen && selectedActivity && (
        <ViewModel
          isOpen={viewModelOpen}
          onClose={() => {
            setViewModelOpen(false);
            setSelectedActivity(null); // Clear selection when modal closes
            setViewedActivityId(null); // Reset viewed activity ID
          }}
          activityTitle={
            selectedActivity.activityId || selectedActivity.id || ""
          }
          expertName={
            selectedActivity.expertData?.name ||
            selectedActivity.expertName ||
            ""
          }
          expertEmail={
            selectedActivity.expertData?.email ||
            selectedActivity.expertEmail ||
            ""
          }
          expertRating={selectedActivity.expertRating}
          expertRatingUser={
            userRatings[
              selectedActivity.expertId || selectedActivity.expertData?.id
            ]?.avgRating || 0
          }
          expertReviewCount={
            userRatings[selectedActivity.expertId]?.totalReviews || 0
          }
          customerName={
            selectedActivity.customerData?.name ||
            selectedActivity.customerName ||
            ""
          }
          customerEmail={
            selectedActivity.customerData?.email ||
            selectedActivity.customerEmail ||
            ""
          }
          customerRating={selectedActivity.customerRating}
          customerRatingUser={
            userRatings[
              selectedActivity.customerId || selectedActivity.customerData?.id
            ]?.avgRating || 0
          }
          customerReviewCount={
            userRatings[
              selectedActivity.customerId || selectedActivity.customerData?.id
            ]?.totalReviews || 0
          }
          activityType={
            selectedActivity.type || selectedActivity.activityType || ""
          }
          activityTime={(() => {
            const getFormattedTime = (activity) => {
              if (activity.startTime?.seconds) {
                return new Date(
                  activity.startTime.seconds * 1000
                ).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                });
              } else if (activity.createdAt?.seconds) {
                return new Date(
                  activity.createdAt.seconds * 1000
                ).toLocaleDateString("en-US", {
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                });
              }
              return "";
            };

            const timeString = new Date(
              selectedActivity.startTime?.seconds * 1000 ||
              selectedActivity.createdAt?.seconds * 1000 ||
              Date.now()
            ).toLocaleTimeString();

            return getFormattedTime(selectedActivity) + ", " + timeString;
          })()}
          activityDuration={(() => {
            const formatDuration = (hours, minutes, seconds) => {
              if (hours > 0) {
                return `${hours}h ${minutes}m`;
              } else if (minutes > 0) {
                return `${minutes}m ${seconds}s`;
              } else {
                return `${seconds}s`;
              }
            };

            if (
              selectedActivity.duration &&
              typeof selectedActivity.duration === "object"
            ) {
              return formatDuration(
                selectedActivity.duration.hours || 0,
                selectedActivity.duration.minutes || 0,
                selectedActivity.duration.seconds || 0
              );
            }
            return selectedActivity.duration || "0s";
          })()}
          activityCost={
            selectedActivity.cost ||
            selectedActivity.amount ||
            selectedActivity.totalAmount ||
            "0"
          }
          activitySavings={selectedActivity.refundAmount || "0"}
          initialNotes={[]} // Add notes handling if needed
          onEditActivity={handleActivityEditFromViewModel}
          activityData={selectedActivity} // Pass the entire activity data object
          expertOrgName={expertOrgName}
          customerOrgName={customerOrgName}
          expertTeamName={expertTeamName}
          customerTeamName={customerTeamName}
          expertteamRole={selectedActivity.expertData?.teamRole || ""}
          customerTeamRole={selectedActivity.customerData?.teamRole || ""}
          expertId={
            selectedActivity.expertData?.uid ||
            selectedActivity.expertData?.id ||
            ""
          }
          customerId={
            selectedActivity.customerData?.uid ||
            selectedActivity.customerData?.id ||
            ""
          }
        />
      )}
      {/* Request Funds Confirmation Popup */}
      {showRequestConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[500px] h-[260px] text-center relative">
            <button
              onClick={() => {
                setShowRequestConfirm(false);
                setPendingRequestAmount("");
              }}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X size={24} />
            </button>
            <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
              You're about to request ${pendingRequestAmount} from your team owner. Ready to send this request?
            </div>
            <div className="flex justify-center gap-4 mt-4">
              <button
                className="py-2 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                onClick={async () => {
                  setShowRequestConfirm(false);
                  await processRequestFunds(pendingRequestAmount);
                  setPendingRequestAmount("");
                }}
                disabled={isProcessing}
              >
                Yes
              </button>
              <button
                className="py-2 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px]"
                onClick={() => {
                  setShowRequestConfirm(false);
                  setPendingRequestAmount("");
                }}
                disabled={isProcessing}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Add Balance Limit Modal (>5000) */}
      {showAddLimitPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[500px] text-center relative">
            <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
              Oops! You can only add up to ₹5,000 at a time.
            </div>
            <div className="flex justify-center gap-4 mt-4">
              <button
                className="py-2 w-[160px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                onClick={() => {
                  setShowAddLimitPopup(false);

                  setInputAmount(pendingAddAmount);
                }}
              >
                Change Amount
              </button>
            </div>
          </div>
        </div>
      )}
      {showAddConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-6  w-[500px] h-[260px]  text-center relative">
            <button
              onClick={() => {
                setShowAddConfirm(false);
                setPendingAddAmount("");
              }}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              <X size={24} />
            </button>
            <div className="mb-6 mt-8 text-[20px] text-gray-800 nunito-semibold">
              You're about to add ₹{pendingAddAmount} to your wallet. Ready to add this amount?
            </div>
            <div className="flex justify-center  gap-4 mt-4">
              <button
                className="py-2 w-[120px] h-[40px] bg-[#F15D18] items-center text-[16px] text-[#FFFFFF] nunito-semibold rounded-[8px] hover:bg-orange-600"
                onClick={async () => {
                  setShowAddConfirm(false);
                  await handleAddBalance(pendingAddAmount);
                  setPendingAddAmount("");
                }}
                disabled={isProcessing}
              >
                Yes
              </button>
              <button
                className="py-2 border w-[120px] h-[40px] items-center border-[#F15D18] text-[#F15D18] nunito-semibold rounded-[8px] "
                onClick={() => {
                  setShowAddConfirm(false);
                  setPendingAddAmount("");
                }}
                disabled={isProcessing}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
     
    </Layout>
  );
};

export default TeamsCustomer;
